<template>
  <div class="draw">
    <el-container class="parent">
      <transition name="slidLeft1">
        <el-aside class="chatList" style="width: 1.7708rem; height: 100%; position: relative; left:0; top:0"
          v-show="showMenu">
          <div class="leftRoot">
            <button class="ll" style="margin-top: 0.1042rem;height:0.2604rem">
              <span style=" font-size: 0.0938rem;">上传参考图</span>
              <el-switch class="switch" v-model="upload" active-color="#06CAF9" inactive-color="#666666"
                @change="uploadSwitch">
              </el-switch>
            </button>

            <button @click="showModel" v-show="true" class="ll" style="padding-bottom:0.0521rem;padding-top:0.0521rem">
              <span style=" font-size: 0.0938rem;">选择大模型</span>
              <div> <span class="modelText">{{ curMoudleAction == "0" ? vlist[0].name : vlist[1].name }}</span>
                <img src="/static/images/build_pop_arr.png" class="arrimg" />
              </div>

            </button>

            <button @click="showModel" v-show="false" class="ll" style="padding-bottom:0.0521rem;padding-top:0.0521rem">
              <span style=" font-size: 0.0938rem;">选择模特</span>
              <span v-if="!modelImg" class="modelText">点击选择</span>
              <div class="modelImg" v-else>
                <el-image class="modelImg" :src="modelImg.modelUrl"></el-image>
                <button class="modelCleanBtn" @click.stop="modelImg = null">
                  不使用
                </button>
              </div>
            </button>

            <div class="ll" v-if="airules" v-for="item in airules" :key="item.titleName">
              <div style="width:100%" v-if="item.configType == 4 && V6enable">
                <button class="llSwtich">
                  <span style=" font-size: 0.0938rem;">{{ item.titleName }}
                    <el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
                      <span></span>
                    </el-tooltip>
                  </span>

                  <el-switch class="switch" v-model="item.switchCheck" active-color="#06CAF9" inactive-color="#666666"
                    @change="uploadItemSwitch(item)">
                  </el-switch>
                </button>
                <el-upload :action="item.titleName" :before-upload="$imgzip" :http-request="handleFGUpload"
                  v-if="item.switchCheck" :show-file-list="false" class="ruleUpload">
                  <div class="singPic" v-if="item.uploadImagUrl">
                    <img :src="$getUploadThumb(item.uploadImagUrl, 200)" class="fileImg" />
                    <div class="exchangeImg">更换图片</div>
                  </div>
                  <div v-else class="uploadBg">
                    <div class="uploadIv"></div>
                    <span>点击上传</span>
                  </div>
                </el-upload>
                <button class="rulellBtn" v-if="item.switchCheck" @click="bindRules(airules.indexOf(item))">
                  <span style=" font-size: 0.0938rem;">{{
            item.subTitleName
          }}</span>

                  <span
                    style="margin-left: 0.0729rem;
                             display: flex;align-items: center;justify-content: center;font-size: 0.0938rem;">{{ item.check ? item.check[0].name : "未选择" }}
                    <img src="/static/images/build_pop_arr.png" class="arrimg" />
                  </span>
                </button>
              </div>

              <button class="rulellBtn" v-if="item.configType != 4" @click="bindRules(airules.indexOf(item))">
                <span style=" font-size: 0.0938rem;">{{ item.titleName }}</span>
                <span v-if="item.configType == 3"
                  style=" margin-left: 0.0729rem;font-size: 0.0938rem;
                            display: flex;align-items: center;justify-content: center; ">{{ item.enable ? item.check : "未启用" }}
                  <img src="/static/images/build_pop_arr.png" class="arrimg" />
                </span>

                <span v-else-if="item.configType == 0"
                  style="margin-left: 0.0729rem;
                             display: flex;align-items: center;justify-content: center;font-size: 0.0938rem;">{{ item.check ? item.check.name : "未选择" }}
                  <img src="/static/images/build_pop_arr.png" class="arrimg" />
                </span>
                <span v-else-if="item.configType == 1"
                  style=" margin-left: 0.0729rem;
                             display: flex;align-items: center;justify-content: center;font-size: 0.0938rem;">{{ item.check.length }}
                  <img src="/static/images/build_pop_arr.png" class="arrimg" />
                </span>

                <el-switch v-else-if="item.configType == 2" class="switch" active-color="#13ce66" v-model="item.check"
                  disabled="false" inactive-color="#ff4949">
                </el-switch>
              </button>
            </div>
            <div v-if="airules" class="llB">
              <button class="leftMenuBtn" @click="clearWorkspace">
                <img src="/static/images/leftbtnLogo.png" alt="" />
                重置创意
              </button>

              <button class="doubleEnnuBtn" @click="hideDoublePop" v-if="false">
                <img src="/static/images/doubleimgclose.png" alt="" />
                服装正反图
              </button>
            </div>
          </div>
          <div class="expBtn" @click="expMenu">
            <div class="shape"></div>
          </div>
        </el-aside>
      </transition>
      <el-main class="drawRoot">
        <div class="drawParent">
          <div class="picbg">
            <div class="pic2pic">
              <div class="ver" v-show="upload && !isDoublePic">
                <el-upload ref="upload" class="picimg" :before-upload="$imgzip" style="background:#1C2134"
                  :action="actionUrl" :http-request="handleUpload" :show-file-list="false">
                  <el-image v-if="imageUrl" :src="$getUploadThumb(imageUrl, 500)" class="upimg" :style="{
            transform: 'rotate(' + deg + 'deg)'
          }" fit="contain">
                    <div slot="placeholder" class="image-slot">
                      <img :src="$getUploadThumb(imageUrl, 500)"
                        style="object-fit: contain;width: 100% ;height: 100%;" />
                    </div>

                    <div slot="error" class="image-slot">
                      <img src="/static/images/img_error.png" style="object-fit: contain;width: 100% ;height: 100%;" />
                    </div>
                  </el-image>

                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <button class="singImgBtn" style="bottom:0.4083rem">
                    {{ !imageUrl ? "点击上传" : "重新上传" }}
                  </button>
                </el-upload>

                <button class=" roate" @click.stop="rotaeUploadImg" v-if="imageUrl">
                  <span style="color: #fff;">旋转</span>
                </button>

                <button class="switchToOne" @click="switchDuble">
                  <img class="reUploadIv" src="/static/images/folder_size_icon.png" />

                  <span>服装正反生成</span>
                </button>
              </div>
              <div class="ver" v-show="upload && isDoublePic">
                <div class="border">
                  <el-upload ref="upload" class="doublePicimg" :before-upload="$imgzip" style="background:#1C2134"
                    :action="actionUrl" :http-request="handleLeftUpload" :show-file-list="false">
                    <el-image v-if="leftImageUrl" :src="$getUploadThumb(leftImageUrl, 500)" class="dupimg"
                      fit="contain">
                      <div slot="placeholder" class="image-slot">
                        <img :src="$getUploadThumb(leftImageUrl, 500)"
                          style="object-fit: contain;width: 100% ;height: 100%;" />
                      </div>

                      <div slot="error" class="image-slot">
                        <img src="/static/images/img_error.png"
                          style="object-fit: contain;width: 100% ;height: 100%;" />
                      </div>
                    </el-image>

                    <div v-else class="dupimg">
                      <img src="/static/images/zhengmian.png" class="dupIconimg" />
                    </div>
                    <button class="singImgBtn">
                      {{ !leftImageUrl ? "点击上传" : "重新上传" }}
                    </button>
                  </el-upload>
                  <el-upload ref="upload" class="doublePicimg" :before-upload="$imgzip" style="background:#1C2134"
                    :action="actionUrl" :http-request="handleRightUpload" :show-file-list="false">
                    <el-image v-if="rightImagUrl" :src="$getUploadThumb(rightImagUrl, 500)" class="dupimg"
                      fit="contain">
                      <div slot="placeholder" class="image-slot">
                        <img :src="$getUploadThumb(rightImagUrl, 500)"
                          style="object-fit: contain;width: 100% ;height: 100%;" />
                      </div>

                      <div slot="error" class="image-slot">
                        <img src="/static/images/img_error.png"
                          style="object-fit: contain;width: 100% ;height: 100%;" />
                      </div>
                    </el-image>

                    <div v-else class="dupimg">
                      <img src="/static/images/fanmian.png" class="dupIconimg" />
                    </div>
                    <button class="singImgBtn">
                      {{ !rightImagUrl ? "点击上传" : "重新上传" }}
                    </button>
                  </el-upload>
                </div>
                <button class="switchToOne" @click="switchDuble">
                  <img class="reUploadIv" src="/static/images/doubleimgclose.png" />
                  <span>返回普通模式</span>
                </button>
              </div>
              <div class="divider" v-show="upload" style="width: 0.1042rem;"></div>
              <div class="ver">
                <div class="picimg">
                  <div class="picimgN">
                    <div v-if="curPicInfo.prestate > 1 && curPicInfo.replyMessage">
                      <div class="gridImg" v-if="curPicInfo.action != 'UPSAMPLE2X' &&
            curPicInfo.action != 'UPSAMPLE4X' &&
            curPicInfo.action != 'UPSAMPLE60' &&
            curPicInfo.img4For
            ">
                        <div class="singleImg" v-for="index in 4" :key="index">
                          <el-image class="picimgS" :src="getItemFor4smallImg(curPicInfo.img4For[index - 1])
            " :style="getBorderStyle(index - 1)" @click="
            prevBigForImg(
              curPicInfo.img4For,
              index - 1,
              curPicInfo.width,
              curPicInfo.height
            )
            " fit="contain" id="image">
                            <div slot="placeholder" class="picimgS">
                              <img src="/static/images/imgplaceloadr.png"
                                style="object-fit: contain;width: 100%;height: 100%;" />
                            </div>
                            <div slot="error" class="image-slot">
                              <img src="/static/images/shengchengshibai.png"
                                style="object-fit: contain;width: 100% ;height: 100%;" />18157161093
                            </div>
                          </el-image>

                          <button class="uploadWork" v-show="canUploadCasecp"
                            @click.stop="showUploadWork(curPicInfo, index)">
                            上传案例
                          </button>
                        </div>
                      </div>
                      <el-image @click="prevBigForImg(curPicInfo.replyMessage)" fit="contain" v-if="curPicInfo.action == 'UPSAMPLE2X' ||
            curPicInfo.action == 'UPSAMPLE4X' ||
            curPicInfo.action == 'UPSAMPLE60'
            " class="picimg" :src="getUpScaleSinglePath(curPicInfo.replyMessage)">
                        <div slot="placeholder" class="picimg">
                          <img src="/static/images/imgplaceloadr.png"
                            style="object-fit: contain;width: 100%;height: 100%;" />
                        </div>
                        <div slot="error" class="image-slot">
                          <img src="/static/images/shengchengshibai.png"
                            style="object-fit: contain;width: 100% ;height: 100%;" />
                        </div>
                      </el-image>
                    </div>

                    <div class="placeImg" v-else></div>
                  </div>
                  <!-- <el-image class="picimg" v-if="curPicInfo.prestate > 1 && curPicInfo.replyMessage"
                                        :src="curPicInfo.replyMessage + '?imageView2/2/w/440/h/440&x-oss-process=image/resize,m_fill,h_440,w_440'"
                                        :preview-src-list="[curPicInfo.replyMessage]" fit="contain" id="image">
                                        <div slot="placeholder" class="image-slot">
                                            <img :src="curPicInfo.replyMessage + '?imageView2/2/w/440/h/440&x-oss-process=image/resize,m_fill,h_440,w_440'"
                                                style="object-fit: cover;">
                                        </div>
                                        <div slot="error" class="image-slot">
                                            <img src="/static/images/shengchengshibai.png" style="object-fit: cover;">
                                        </div>

                                    </el-image> -->
                  <div class="progressDiv" v-if="(curPicInfo.progress &&
            curPicInfo.progress != '100%' &&
            curPicInfo.prestate &&
            curPicInfo.prestate <= 2) ||
            curPicInfo.state === 2
            ">
                    <img class="pic_progress" src="/static/images/loadimg.gif" />
                    <div v-if="curPicInfo.isRunning" class="progress">
                      预计完成时间 {{ curPicInfo.endTime }} 秒
                    </div>
                    <div v-else class="progress">{{ curPicInfo.queueTip }}</div>
                    <span class="progress" v-show="curPicInfo.isRunning">
                      {{ curPicInfo.progress }}</span>
                  </div>
                  <div class=" placeHolderPre" v-if="!curPicInfo.state && !curPicInfo.prestate"></div>
                  <div :class="curPicInfo.state === 5 ||
            curPicInfo.state === 4 ||
            curPicInfo.state === 3
            ? 'placeHolderPreError'
            : 'placeHolderPre'
            " v-if="curPicInfo.state === 5 || curPicInfo.state === 3">
                    <span v-if="curPicInfo.status && curPicInfo.status == 'IN_PROGRESS'
            ">开始生成,请稍后...</span>
                    <span v-else-if="curPicInfo.status && curPicInfo.status == 'FAILURE'
            ">{{ "生成失败" }} {{ curPicInfo.errMsg }}</span>
                    <span v-else-if="curPicInfo.state == 5">{{ "生成失败" }} {{ curPicInfo.errMsg }}</span>
                    <span v-else-if="curPicInfo.state == 3">{{ "生成失败" }} {{ curPicInfo.errMsg }}</span>
                    <span v-else>正在排队中,请稍后...</span>
                  </div>
                </div>
                <div class="menus" style="margin-top: 0.0521rem;" v-show="curPicInfo.prestate === 3 &&
            curPicInfo.state === 1 &&
            curPicInfo.state !== 5
            ">
                  <div class="menu" v-show="curPicInfo.action !== 'UPSCALE' &&
            curPicInfo.action &&
            curPicInfo.action.indexOf('UPSAMPLE') < 0
            ">
                    <el-popover placement="bottom" trigger="click" popper-class="popoverBackB" v-model="vactionPop">
                      <div class="popBtnLl">
                        <div class="btnLl">
                          <button class="btn vbtn " @click="picAction(curPicInfo, 'V1')">
                            图1
                          </button>
                          <button class="btn vbtn " @click="picAction(curPicInfo, 'V2')">
                            图2
                          </button>
                          <button class="btn vbtn " @click="picAction(curPicInfo, 'V3')">
                            图3
                          </button>
                          <button class="btn vbtn " @click="picAction(curPicInfo, 'V4')">
                            图4
                          </button>
                          <div class="btnDivider"></div>
                          <div class="btnText">相似度</div>
                          <div class="btnText" :style="{
            color: vactionStyle ? '#dfe5ef' : '#409EFF'
          }">
                            高
                          </div>
                          <el-switch v-model="vactionStyle" class="switchVation">
                          </el-switch>
                          <div class="btnText" :style="{
            color: vactionStyle ? '#409EFF' : '#dfe5ef'
          }">
                            低
                          </div>
                          <!-- <button class="btn vbtn "
                                                    @click="picAction(curPicInfo, 'OUTPAINT1')">上移</button>
                                                <button class="btn vbtn " @click="picAction(curPicInfo, 'U1')">U1</button> -->
                        </div>
                        <div class="btnLl" v-if="false">
                          <button class="btn vbtn " @click="picAction(curPicInfo, 'SEEDIMAGE1')">
                            图1
                          </button>
                          <button class="btn vbtn " @click="picAction(curPicInfo, 'SEEDIMAGE2')">
                            图2
                          </button>
                          <button class="btn vbtn " @click="picAction(curPicInfo, 'SEEDIMAGE3')">
                            图3
                          </button>
                          <button class="btn vbtn " @click="picAction(curPicInfo, 'SEEDIMAGE4')">
                            图4
                          </button>
                          <div class="btnDivider"></div>
                          <div class="btnText">采用相似生成</div>
                        </div>
                      </div>
                      <button class="itBbtn " slot="reference"
                        v-if="curPicInfo.action !== 'IMAGINEINSD' && curPicInfo.engineType != '2'">
                        <img src="/static/images/fourYanshen.png" />
                        延伸
                      </button>
                    </el-popover>
                    <el-popover placement="bottom" trigger="click" popper-class="popoverBackB" v-model="outactionPop">
                      <div class="btnLl">
                        <button class="btn vbtn " @click="picAction(curPicInfo, 'OUTPAINT1')">
                          图1
                        </button>
                        <button class="btn vbtn " @click="picAction(curPicInfo, 'OUTPAINT2')">
                          图2
                        </button>
                        <button class="btn vbtn " @click="picAction(curPicInfo, 'OUTPAINT3')">
                          图3
                        </button>

                        <button class="btn vbtn " @click="picAction(curPicInfo, 'OUTPAINT4')">
                          图4
                        </button>
                      </div>
                      <button class="itBbtn " slot="reference"
                        v-if="curPicInfo.action !== 'IMAGINEINSD' && curPicInfo.engineType != '2'">
                        <img src="/static/images/quanjingicon.png" />
                        扩绘
                      </button>
                    </el-popover>

                    <el-popover placement="bottom" trigger="click" popper-class="popoverBackB" v-if="!isV6 && !UPSAMPLE"
                      v-model="scaleActionPop">
                      <!-- <div class="btnLl">
                                                <button class="btn vbtn "
                                                    @click="picAction(curPicInfo, 'UPSAMPLE4X1')">图1</button>
                                                <button class="btn vbtn "
                                                    @click="picAction(curPicInfo, 'UPSAMPLE4X2')">图2</button>
                                                <button class="btn vbtn "
                                                    @click="picAction(curPicInfo, 'UPSAMPLE4X3')">图3</button>

                                                <button class="btn vbtn "
                                                    @click="picAction(curPicInfo, 'UPSAMPLE4X4')">图4</button>


                                            </div> -->

                      <div class="btnLl">
                        <button class="btn vbtn " @click="selectScaleAction(curPicInfo, 1)">
                          图1
                        </button>
                        <button class="btn vbtn " @click="selectScaleAction(curPicInfo, 2)">
                          图2
                        </button>
                        <button class="btn vbtn " @click="selectScaleAction(curPicInfo, 3)">
                          图3
                        </button>

                        <button class="btn vbtn " @click="selectScaleAction(curPicInfo, 4)">
                          图4
                        </button>
                      </div>
                      <button class="itBbtn " slot="reference" v-if="!isV6 &&
            !UPSAMPLE &&
            curPicInfo.action !== 'IMAGINEINSD' && curPicInfo.engineType != '2'
            ">
                        <img src="/static/images/scaleicon.png" />
                        放大
                      </button>
                    </el-popover>

                    <el-popover placement="bottom" trigger="click" popper-class="popoverBackB" v-if="isV6 && !UPSAMPLE"
                      v-model="scaleActionPop">
                      <div class="btnLl">
                        <button class="btn vbtn " @click="picAction(curPicInfo, 'UPSAMPLE601')">
                          图1
                        </button>
                        <button class="btn vbtn " @click="picAction(curPicInfo, 'UPSAMPLE602')">
                          图2
                        </button>
                        <button class="btn vbtn " @click="picAction(curPicInfo, 'UPSAMPLE603')">
                          图3
                        </button>

                        <button class="btn vbtn " @click="picAction(curPicInfo, 'UPSAMPLE604')">
                          图4
                        </button>
                      </div>
                      <button class="itBbtn " slot="reference" v-if="isV6 &&
            !UPSAMPLE &&
            curPicInfo.action !== 'IMAGINEINSD'
            && curPicInfo.engineType != '2'
            ">
                        <img src="/static/images/scaleicon.png" />
                        放大
                      </button>
                    </el-popover>

                    <el-popover placement="bottom" trigger="click" popper-class="popoverBackB" v-model="collectPop">
                      <div class="btnLl">
                        <button class="btn vbtn " @click="clickCollectImg(curPicInfo.id, [0])">
                          图1
                        </button>
                        <button class="btn vbtn " @click="clickCollectImg(curPicInfo.id, [1])">
                          图2
                        </button>
                        <button class="btn vbtn " @click="clickCollectImg(curPicInfo.id, [2])">
                          图3
                        </button>
                        <button class="btn vbtn " @click="clickCollectImg(curPicInfo.id, [3])">
                          图4
                        </button>
                        <button class="btn vbtn " @click="clickCollectImg(curPicInfo.id, [0, 1, 2, 3])">
                          全部
                        </button>
                      </div>

                      <button class="itBbtn " slot="reference">
                        <img src="/static/images/fourCollect.png" />
                        收藏
                      </button>
                    </el-popover>

                    <el-popover placement="bottom" trigger="click" popper-class="popoverBackB" v-model="downloadPop">
                      <div class="btnLl">
                        <button class="btn vbtn " @click="
            downloadSingleImg(
              curPicInfo.id,
              [curPicInfo.img4For[0]],
              0
            )
            ">
                          图1
                        </button>
                        <button class="btn vbtn " @click="
            downloadSingleImg(
              curPicInfo.id,
              [curPicInfo.img4For[1]],
              1
            )
            ">
                          图2
                        </button>
                        <button class="btn vbtn " @click="
            downloadSingleImg(
              curPicInfo.id,
              [curPicInfo.img4For[2]],
              2
            )
            ">
                          图3
                        </button>
                        <button class="btn vbtn " @click="
            downloadSingleImg(
              curPicInfo.id,
              [curPicInfo.img4For[3]],
              3
            )
            ">
                          图4
                        </button>
                        <button class="btn vbtn " @click="
            downloadSingleImg(
              curPicInfo.id,
              curPicInfo.img4For,
              3
            )
            ">
                          全部
                        </button>
                      </div>

                      <button class="itBbtn " slot="reference">
                        <img src="/static/images/fourDown.png" />
                        下载
                      </button>
                    </el-popover>

                    <el-popover placement="bottom" trigger="click" popper-class="popoverBackB" v-if="hasInpintRight"
                      v-model="regionctionPop">
                      <div class="btnLl">
                        <button class="btn vbtn " @click="
            openRegionPop(
              getItemFor4smallImg(curPicInfo.img4For[0]),
              1
            )
            ">
                          图1
                        </button>
                        <button class="btn vbtn " @click="
            openRegionPop(
              getItemFor4smallImg(curPicInfo.img4For[1]),
              2
            )
            ">
                          图2
                        </button>
                        <button class="btn vbtn " @click="
            openRegionPop(
              getItemFor4smallImg(curPicInfo.img4For[2]),
              3
            )
            ">
                          图3
                        </button>
                        <button class="btn vbtn " @click="
            openRegionPop(
              getItemFor4smallImg(curPicInfo.img4For[3]),
              4
            )
            ">
                          图4
                        </button>
                      </div>
                      <button class="itBbtn " slot="reference" v-show="hasInpintRight && curPicInfo.action !== 'IMAGINEINSD'
            && curPicInfo.engineType != '2'">
                        <img src="/static/images/redraw_icon.png" />
                        微调
                      </button>
                    </el-popover>
                  </div>
                  <div class="menu" v-if="curPicInfo.action &&
            curPicInfo.action.indexOf('UPSAMPLE') > -1
            ">
                    <button class="itBbtn " @click="clickCollectImg(curPicInfo.id, [1])">
                      <img src="/static/images/fourCollect.png" />
                      收藏
                    </button>
                    <button class="itBbtn " @click="
            downloadSingleImg(curPicInfo.id, [
              curPicInfo.replyMessage
            ])
            ">
                      <img src="/static/images/fourDown.png" />
                      下载
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="empty" v-show="false">
              <span>画作欣赏</span>
              <img src="/static/images/superLucky_cat_7adff9a3-55c2-41f3-826e-0a453eb3e778.webp" />
              <span class="picTitle">期待你的创作！ 快去输入你的创意吧～</span>
            </div>
          </div>
          <div class="editBot">
            <div class="editBg" style="padding-left:  0.7008rem;">
              <el-input class="input" type="textarea" :autosize="{ minRows: 4, maxRows: 5 }" @input="removeNewlines"
                placeholder="写下你的创意" v-model="propMsg" resize="none" @keyup.enter.native="send">
              </el-input>
              <button class="sendBtnLeft" @click="showPropPop = true">
                提示助理
              </button>
            </div>
            <div class="editDivider" style="height:1px"></div>
            <div class="editBg">
              <el-input class="input" type="textarea" :autosize="{ minRows: 3, maxRows: 4 }" resize="none"
                style="padding-right:  0.4208rem;" placeholder="选择你的创意参数" readonly v-model="realPropMsg">
              </el-input>
              <button class="sendBtn" @click="sendForType">一键生成</button>
            </div>
          </div>
        </div>

        <div class="rightList">
          <div class="rightTtile">
            <!-- <div class="listTab">
                            <button :class="isShowFail ?
                                'ltab_n' : 'ltab'" @click="switchFailList(false)">创作记录</button>
                            <button :class="isShowFail ?
                                'ltab' : 'ltab_n'" @click="switchFailList(true)">更多</button>
                        </div> -->
            <span>创作记录</span>

            <button @click="goTop" v-show="showBackTop" class="btopBtn"></button>
          </div>
          <!-- <div class="waterfall">
                        <vue-waterfall-easy ref="waterfall" :imgsArr="imgsArr" srcKey="src" :imgWidth="260" :gap="4"
                            @scrollReachBottom="getData" @preloaded="imgLoad" @click="clickFn" :maxCols="1">
                            <div class="img-info" slot-scope="props">

                            </div>
                        </vue-waterfall-easy>
                    </div> -->
          <van-list class="van-list" v-model="isLoading" :finished="finished" finished-text="没有更多了" ref="vanList"
            @scroll="listScroll" @load="onLoad">
            <div v-for="item in list" :key="item.id" @click="restCurPic(item)"
              :class="item === curPicInfo ? 'recordItem_c' : 'recordItem'">
              <div v-if="item.replyMessage &&
            (!item.progress || item.progress == '100%') &&
            item.state != 5
            " style="position: relative;">
                <div class="gridImgList" v-if="item.img4For">
                  <el-image v-for="index in 4" :key="index" class="singleImgList"
                    :src="getItemFor4smallImg(item.img4For[index - 1])" :style="getBorderStyle(index - 1)" fit="contain"
                    id="image">
                    <div slot="placeholder" class="singleImgList">
                      <img src="/static/images/imgplaceloadr.png"
                        style="object-fit: contain;width: 100%;height: 100%;" />
                    </div>

                    <div slot="error" class="image-slot">
                      <img src="/static/images/shengchengshibai.png"
                        style="object-fit: contain;width: 100% ;height: 100%;" />
                    </div>
                  </el-image>
                </div>

                <el-image v-if="item.action.indexOf('UPSAMPLE') > -1" :src="getUpScaleSinglePath(item.replyMessage)"
                  fit="contain" class="bigWidth" id="image">
                  <div slot="placeholder" class="singleImgList">
                    <img src="/static/images/imgplaceloadr.png"
                      style="object-fit: contain;width: 100% ;height: 100%;" />
                  </div>

                  <div slot="error" class="image-slot">
                    <img src="/static/images/shengchengshibai.png"
                      style="object-fit: contain;width: 100% ;height: 100%;" />
                  </div>
                </el-image>
              </div>

              <div class="failIv" v-if="item.errMsg || item.state === 5 || item.state === 3">
                <div class="errMsg">
                  <img src="/static/images/picbuild_fial.png" id="errmsgIv" />
                  <span class="errText">{{
            item.errMsg ? item.errMsg : "生成失败"
          }}</span>
                </div>
              </div>

              <div class="progressBg" v-if="(item.progress && item.progress != '100%') || item.state === 2
            ">
                <img src="/static/images/loadimg.gif" id="proIv" />
                <div v-if="item.isRunning">
                  预计完成时间 {{ item.endTime }}秒
                </div>

                <div v-else class="progress">{{ item.queueTip }}</div>

                <div v-show="item.isRunning">{{ item.progress }}</div>

                <div class="itemProgerss" v-if="item.progress && item.isRunning">
                  <el-progress :percentage="parseInt(
            item.progress.substr(0, item.progress.indexOf('%'))
          )
            " :stroke-width="4" class="Listprogress" v-show="false"></el-progress>
                </div>
              </div>

              <div class="listCover">
                <template>
                  <el-popconfirm title="刷新任务 " @confirm="retryAdd(item)">
                    <div class="listDelete" @click.stop="none" slot="reference"
                      style=" background-image: url('/static/images/shuaxin1.png');"
                      v-show="item.state == 2 && demoFlag"></div>
                  </el-popconfirm>
                </template>

                <template>
                  <el-popconfirm title="确认删除记录么 " @confirm="deleteRecord(item)">
                    <div class="listDelete" @click.stop="none" slot="reference" v-show="item.state != 2"></div>
                  </el-popconfirm>
                </template>
                <template>
                  <el-popconfirm title="置顶任务 " @confirm="upTask(item)">
                    <div class="listUp" @click.stop="none" slot="reference"></div>
                  </el-popconfirm>
                </template>
              </div>
            </div>
          </van-list>
        </div>
        <div class="expBtn leftBtn" v-show="!showMenu" @click="expMenu">
          <div class="shapeR"></div>
        </div>
      </el-main>
    </el-container>
    <transition name="el-fade-in-linear">
      <div class="pop" v-if="showSelectPop" @click.self="showSelectPop = !showSelectPop">
        <div class="selectPop">
          <div class="popRoot">
            <span
              style="margin-top: 0.2083rem;color: #fff; font-size: 0.1146rem; margin-bottom: 0.0881rem;">写下你的创意</span>
            <div class="rulesContent" ref="ruleBg">
              <div v-for="item in airules" :key="item.titleName" ref="ruleDiv">
                <div class="popLl" v-if="item.configType != 4 ||
            (item.configType == 4 && item.switchCheck && V6enable)
            ">
                  <span class="indexbar"></span>
                  <span>{{ item.titleName }}</span>
                </div>
                <div v-if="item.configType == 0">
                  <div v-if="item.configList[0].imageUrl" class="ruleList">
                    <div v-for="it in item.configList" :key="it.name" @click="usercheck(item, it)">
                      <button v-if="item &&
            item.check &&
            it &&
            JSON.stringify(item.check) == JSON.stringify(it)
            " class="tagImg_s tagFlex">
                        <img :src="it.imageUrl" />
                        <span> {{ it.name }}</span>
                      </button>
                      <button v-else class="tagImg tagFlex">
                        <img :src="it.imageUrl" />
                        <span> {{ it.name }}</span>
                      </button>
                    </div>
                  </div>
                  <div v-else class="ruleList">
                    <div v-for="it in item.configList" :key="it.name" @click="usercheck(item, it)">
                      <button v-if="item &&
            item.check &&
            it &&
            JSON.stringify(item.check) == JSON.stringify(it)
            " class="tag_s">
                        <span> {{ it.name }}</span>
                      </button>
                      <button v-else class="tag">
                        <span> {{ it.name }}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="item.configType == 1" class="ruleList">
                  <div v-for="it in item.configList" :key="it" @click="usercheck(item, it)">
                    <button v-if="item.check.indxOf(it) != -1">
                      <span> {{ it.name }}</span>
                    </button>
                    <button v-else class="tag">
                      <span> {{ it.name }}</span>
                    </button>
                  </div>
                </div>
                <div v-else-if="item.configType == 2">
                  <div class="ruleLl">
                    <el-switch class="switch" active-color="#13ce66" v-model="item.check" inactive-color="#ff4949">
                    </el-switch>
                  </div>
                </div>
                <div v-else-if="item.configType == 3 &&
            item.configList &&
            item.configList.length > 0
            ">
                  <div class="ruleLl">
                    <el-slider class="sliderBarBig" v-model="item.check" :min="item.configList[0].minNum"
                      :show-tooltip="false" @change="slderChange(item)" :max="item.configList[0].maxNum"></el-slider>
                    <div class="sliderText">{{ item.check }}</div>
                    <span style="margin-left:120px;margin-right:10px;">是否启用</span>
                    <el-switch class="switch" active-color="#06CAF9" v-model="item.enable" inactive-color="#666666">
                    </el-switch>
                  </div>
                </div>
                <div v-else-if="item.configType == 4 &&
            item.configList.length > 0 &&
            item.switchCheck &&
            V6enable
            ">
                  <el-upload :action="item.titleName" :before-upload="$imgzip" :http-request="handleFGUpload"
                    v-if="item.switchCheck" :show-file-list="false" class="ruleUpload"
                    style="padding-left:0.2083rem;margin-top:0.1042rem">
                    <div class="singPic" v-if="item.uploadImagUrl">
                      <img :src="$getUploadThumb(item.uploadImagUrl, 200)" class="fileImg" />
                      <div class="exchangeImg">更换图片</div>
                    </div>
                    <div v-else class="uploadBg">
                      <div class="uploadIv"></div>
                      <span>点击上传</span>
                    </div>
                  </el-upload>
                  <div class="ruleList">
                    <div v-for="it in item.configList" :key="it.name" @click="usercheck(item, it)">
                      <button v-if="item &&
            item.check &&
            it &&
            JSON.stringify(item.check[0]) == JSON.stringify(it)
            " class="tag_s">
                        <span> {{ it.name }}</span>
                      </button>
                      <button v-else class="tag">
                        <span> {{ it.name }}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else></div>
              </div>
            </div>
            <div class="resetBtns">
              <button class="resetBtn" @click="resetRules(airules)">
                重置
              </button>
              <div style="width: 0.8333rem;"></div>
              <button class="setBtn" @click="hidePop">确定</button>
            </div>
            <img src="/static/images/close.png" class="popClose" @click="hidePop" />
          </div>
        </div>
      </div>
    </transition>
    <div class="pop" v-show="editRegionPop">
      <div class="editRegionPop">
        <shapeDrawer @exportImg1="onImgExport" ref="shapeDrawer" @hidePop="hideEditPop"></shapeDrawer>
      </div>
    </div>

    <div class="pop" v-show="doublePicPop">
      <div class="doubleImgPop">
        <div class="doublePopTitle">正反面生成</div>

        <div class="imgaeList">
          <el-upload class="dpicimg" :before-upload="$imgzip" :action="actionUrl" :http-request="handleLeftUpload"
            :show-file-list="false">
            <el-image v-if="leftImageUrl" :src="$getUploadThumb(leftImageUrl, 500)" class="dupimg" fit="contain">
              <div slot="placeholder" class="image-slot">
                <img :src="$getUploadThumb(leftImageUrl, 500)" style="object-fit: contain;width: 100% ;height: 100%;" />
              </div>

              <div slot="error" class="image-slot">
                <img src="/static/images/img_error.png" style="object-fit: contain;width: 100% ;height: 100%;" />
              </div>
            </el-image>
            <div v-else class="dimgplaceBg">
              <div class="doubleImgicon"></div>
              <div>点击此处上传服装正面图片</div>
            </div>
          </el-upload>
          <el-upload class="dpicimg" :before-upload="$imgzip" :action="actionUrl" :http-request="handleRightUpload"
            :show-file-list="false">
            <el-image v-if="rightImagUrl" :src="$getUploadThumb(rightImagUrl, 500)" class="dupimg" fit="contain">
              <div slot="placeholder" class="image-slot">
                <img :src="$getUploadThumb(rightImagUrl, 500)" style="object-fit: contain;width: 100% ;height: 100%;" />
              </div>

              <div slot="error" class="image-slot">
                <img src="/static/images/img_error.png" style="object-fit: contain;width: 100% ;height: 100%;" />
              </div>
            </el-image>
            <div v-else class="dimgplaceBg">
              <div class="doubleImgicon"></div>
              <div>点击此处上传服装背面图片</div>
            </div>
          </el-upload>
        </div>

        <div class="doubleInput">
          <el-input style="width: 100%;height: 100%;" type="textarea" :autosize="{ minRows: 5, maxRows: 5 }"
            @input="removeNewlines" placeholder="写下你的创意" v-model="propMsg" resize="none">
          </el-input>
          <div class="doubleSendBtn" @click="makeDoubleImgTask">一键生成</div>
        </div>
        <img src="/static/images/close.png" class="popClose" @click="hideDoublePop" />
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <div class="pop" v-if="showPropPop" @click.self="showPropPop = !showPropPop">
        <div class="selectPopProp">
          <div class="popRoot">
            <span
              style="margin-top: 0.1083rem;color: #fff; font-size: 0.1146rem; margin-bottom: 0.0881rem;">写下你的创意</span>

            <img src="/static/images/close.png" class="popClose" @click="showPropPop = !showPropPop" />
            <div class="propTabs">
              <button v-for="item in propTabs" :class="item == curSlectTabs ? 'selTabBtn' : 'TabBtn'"
                @click="selectTab(item)" v-bind:key="item.id">
                {{ item.promptTypeName }}
              </button>
            </div>
            <div class="tabDivider"></div>
            <div class="propGrid">
              <button v-for="item in propDetail" @click="clickText(item.prompt)" v-bind:key="item.id"
                :class="propTextList.indexOf(item.prompt) > -1 ? 'sel' : ''">
                {{ item.prompt }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="el-fade-in-linear">
      <div class="pop" v-if="false" @click.self="showModelPop = !showModelPop">
        <div class="selectPopProp">
          <div class="popRoot">
            <span
              style="margin-top: 0.1083rem;color: #fff; font-size: 0.1146rem; margin-bottom: 0.0881rem;">选择您要锁定的模特</span>

            <img src="/static/images/close.png" class="popClose" @click="showModelPop = !showModelPop" />
            <div class="propTabs">
              <button v-for="item in modelTypes" :class="item == curModelType ? 'selTabBtn' : 'TabBtn'"
                @click="curModelType = item" v-bind:key="item.id">
                {{ item.modelTypeName }}
              </button>
            </div>
            <div class="tabDivider"></div>
            <div class="propGrid">
              <div class="modelItem" v-for="item in curModelType.modelFaceConfigList" @click="selectModeImg(item)"
                v-bind:key="item.id" :class="modelImg == item ? 'sel' : ''">
                <el-image :src="item.modelUrl" class="dupimg" fit="contain">
                  <div slot="placeholder" class="image-slot">
                    <img :src="item.modelUrl" style="object-fit: contain;width: 100% ;height: 100%;" />
                  </div>

                  <div slot="error" class="image-slot">
                    <img src="/static/images/img_error.png" style="object-fit: contain;width: 100% ;height: 100%;" />
                  </div>
                </el-image>
                <div class="modelSpan">{{ item.modelName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>


    <transition name="el-fade-in-linear">
      <div class="pop" v-if="showModelPop" @click.self="showModelPop = !showModelPop">
        <div class="selectPopProp">
          <div class="popRoot">
            <span
              style="margin-top: 0.1083rem;color: #fff; font-size: 0.1146rem; margin-bottom: 0.0881rem;">选择您要使用的大模型</span>

            <img src="/static/images/close.png" class="popClose" @click="showModelPop = !showModelPop" />
            <div class="arls">
              <div v-for="item in vlist" :key="item.name">
                <button v-if="item.value == curMoudleAction" class="check" @click="slectAr(item.value)">
                  {{ item.name }}
                </button>
                <button v-else @click="slectAr(item.value)">{{ item.name }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>


    <uploadWorkPop :showPropPop="false" @uploadWork="uploadWork" ref="uplaodTaskPop"></uploadWorkPop>
    <el-image-viewer style="z-index:1500" v-if="showImageViewer" :on-close="() => {
            showImageViewer = false;
          }
            " :url-list="imageData" :initial-index="viewerIndex" :thumbnail="400" :prevHeight="prevHeight"
      :prevWidth="prevWidth">
      <div class="placeholder"></div>
    </el-image-viewer>
  </div>
</template>

<script>
import vueWaterfallEasy from "vue-waterfall-easy";
import { upload } from "@/utils/upload";
import { formatDate } from "@/utils/date";
import { getToken } from "@/utils/auth";
import shapeDrawer from "@/components/shapeDrawer";
import uploadWorkPop from "@/components/uploadWorkPop";
import bus from "@/utils/bus";
import axios from "axios";
import {
  chatStream as mjChatStream,
  send as sendMj,
  sendStatus,
  getDetail,
  SDgetDetail as getSDDetail,
  ruleList,
  propTabList,
  propDetail,
  getDemoFlag
} from "@/api/ai/AiChatMjLogs";
import { downloadSingleImg, downImageForApi } from "@/utils/imagedownload.js";
import { getAllAlbumList, addCollect } from "@/api/works/photos.js";
import {
  getList as getTitleList,
  getUserRight,
  addImgInfo,
  topTask
} from "@/api/user/userChatTitle";
import {
  add,
  getList as getContentList,
  remove,
  show as getInfoForItem,
  getModelTypeList
} from "@/api/user/userChatContent";
import { getUploadCaseFlag } from "@/api/ai/userAiChatType.js";

// 每次点生成 生成新纪录

export default {
  name: "Chat",
  data() {
    return {
      // 大图预览
      viewerIndex: 0,
      modelImg: null,
      imageData: [],
      showImageViewer: false,
      downloadPop: false,
      uploadCK: false,
      regionctionPop: false,
      vactionPop: false,
      outactionPop: false,
      scaleActionPop: false,
      isDoublePic: false,
      collectPop: false,
      propMsg: null,
      propTabs: [],
      vlist: [
        { name: "2.0", value: "0" },
        { name: "2.0Pro", value: "2" },

      ],
      curMoudleAction: "0",
      propTextList: [],
      modelTypes: [],
      curModelType: null,
      propDetail: [],
      curSlectTabs: null,
      showSelectPop: false,
      showPropPop: false,
      showCollectPop: false,
      editRegionPop: false,
      doublePicPop: false,
      imgchats: [],
      albumList: [],
      prevWidth: null,
      prevHeight: null,
      equityType: "2",
      messageType: 1,
      showFullList: false,
      image2prompt: "1",
      imageUrl: null,
      succeed: true,
      upload: false,
      isShowFail: false,
      list: [],
      pages: 1,
      pageSize: 20,
      vactionStyle: true,
      pageNum: 1,
      menuClass: "leftRoot",
      chatType: 0,
      refreshTaskIdList: [],
      ruleTempId: null,
      ruleTempSdId: null,
      sdRuleDetail: [],
      apiRuleDetail: [],
      actionUrl: "",
      deg: 0,
      demoFlag: false,
      taskRecords: [],
      showModelPop: false,
      templates: [],
      airules: [],
      isdownLoadImg: false,
      showMenu: true,
      chatDetailId: null,
      recontime: 0,
      mjEventSource: null,
      curPicInfo: {},
      isV6: false,
      UPSAMPLE: false,
      imgsArr: [],
      moveCurAlbumPop: null,
      finished: false,
      isLoading: false,
      imggesWithSizeData: {},
      actionMsg: null,
      // 进度关联
      taskMap: {},
      showBackTop: false,
      inpaintPrompt: null,
      hasInpintRight: false,
      pendingAITasks: [],
      leftImageUrl: null,
      rightImagUrl: null,
      V6enable: true,
      canUploadCase: false
    };
  },
  created() {
    const maptInfo = localStorage.getItem("taskMap");
    const recrods = sessionStorage.getItem("taskRecordsBuild");
    if (recrods) {
      this.taskRecords = JSON.parse(recrods);
    } else {
      this.taskRecords = [];
    }
    console.log(this.taskRecords);
    if (maptInfo) {
      this.taskMap = JSON.parse(maptInfo);
      for (const o in this.taskMap) {
        const obj = this.taskMap[o];
        const curTime = new Date().getTime();
        if (curTime - obj.createTime > 1000 * 60 * 8) {
          //  console.log('delete  === ' + o)
          delete this.taskMap[o];
        }
      }
      localStorage.setItem("taskMap", JSON.stringify(this.taskMap));
      this.curSlectTabs = this.propTabs[0];
    }
  },
  mounted() {
    if (getToken()) {
      this.mjcon();
      this.isLoading = false;
      this.getRules();
      this.getUserRight();
      getModelTypeList().then(res => {
        // console.log(res.data)
        this.modelTypes = [{
          modelName: 'sssss'
        }, { modelName: 'sssss' }, { modelName: 'sssss' }];
        this.curModelType = this.modelTypes[0];
      });

      if (this.$route.params.type) {
      } else {
        this.propMsg = this.$route.params.key;
      }
      getUploadCaseFlag().then(res => {
        this.canUploadCase = res.data == 1;
      });

      getAllAlbumList().then(res => {
        this.albumList = res.data;
      });
    } else {
      this.$message("请先登录");
      bus.$emit("showLogin");
    }

    bus.$on("loginSucess", call => {
      //
      //    this.pageNum = 1
      //     this.pages = 1
      // this.mjcon()
      // this.onLoad()
      // this.isLoading = false
      // this.getRules()
      // this.getUserRight()
      // getAllAlbumList().then(res => {
      //     this.albumList = res.data

      // })
      location.reload();
    });
    const container = this.$refs.vanList.$el;
    container.addEventListener("scroll", this.listScroll);
  },

  computed: {
    realPropMsg: {
      cache: true,
      get() {
        if (this.airules) {
          let str = "";

          for (const it of this.airules) {
            if (it.check) {
              if (it.configType === 4 && !this.V6enable) {
                continue;
              }

              if (it.configType === 3 && !it.enable) {
                continue;
              }

              str += it.titleName;
              if (it.configType === 0) {
                str += it.check.name;
              } else if (it.configType === 1) {
                for (ir of it.configList) {
                  str += ir.name;
                }
              } else if (it.configType === 3) {
                str += it.check;
              } else if (it.chatType === 2) {
                str += it.check;
              }
              if (it.configType === 4 && this.V6enable) {
                str += it.check[0].name;
              }
              str += ",";
            }
          }
          let ss = "";
          if (this.curPicInfo.jobId) {
            ss += "  任务编号：" + this.curPicInfo.jobId;
            ss +=
              " " + this.curPicInfo.jobState == 1 ? "（进行中）" : "（已结束）";
            ss +=
              " 执行状态：" +
              this.curPicInfo.jobDoneNum +
              "/" +
              this.curPicInfo.jobFailNum +
              "/" +
              this.curPicInfo.jobNum;
          }
          return str.substring(0, str.length - 1) + ss;
        }
        return "";
      }
    },
    canUploadCasecp() {
      if (!this.canUploadCase) {
        return false;
      }
      return true;
      // if (
      //   this.curPicInfo.action == "IMAGINE" ||
      //   this.curPicInfo.action == "VARIATION" ||
      //   this.curPicInfo.action == "LOWVARIATION" ||
      //   this.curPicInfo.action == "INPAINT"
      // ) {
      //   return true;
      // }
    }
  },
  beforeDestroy() {
    bus.$off("loginSucess");
    clearInterval(this.pageServerId);

    if (this.mjEventSource) {
      this.mjEventSource.close();
    }
    if (this.taskMap) {
      for (const o in this.taskMap) {
        // console.log(o)
        const obj = this.taskMap[o];
        //  console.log(obj)
        if (obj.taskId) {
          // console.log('delete   taskId == ' + obj.taskId)
          obj.isPasue = true;
          clearInterval(obj.taskId);
        }
        if (obj.submitTaskId) {
          // console.log('delete   taskId == ' + obj.taskId)
          console.log("stop   submitTaskId == " + obj.submitTaskId);
          clearInterval(obj.submitTaskId);
        }
        if (obj.endTaskId) {
          // console.log('cancel   endTaskId == ' + obj.endTaskId)

          clearInterval(obj.endTaskId);
        }
      }
      localStorage.setItem("taskMap", JSON.stringify(this.taskMap));
      for (const id of this.refreshTaskIdList) {
        clearInterval(id);
      }
    }
  },
  watch: {
    imageUrl(newval, oldval) {
      this.deg = 0;
    }
  },

  methods: {
    selectModeImg(item) {
      this.modelImg = item;
      this.showModelPop = false;
    },
    slectAr(value) {
      //
      if (this.curMoudleAction != value) {
        this.curMoudleAction = value;
        if (this.curMoudleAction == 0) {
          this.resetRules(this.apiRuleDetail);
          this.airules = this.apiRuleDetail;
        } else {
          this.resetRules(this.sdRuleDetail);
          this.airules = this.sdRuleDetail;
        }
      }
      this.showModelPop = false



      //if(this.getde)
    },
    parsePageForTry(params) {
      // this.slectAr('2')
      this.vactionStyle = true;
      this.propMsg = params.message;
      this.resetHisPicRules(params.subText);


      if (params.imageMessageUrl || params.mergeUrls) {
        this.upload = true;
        if (params.imageMessageUrl) {
          this.isDoublePic = false;
          this.imageUrl = params.imageMessageUrl[0];
        } else {
          this.imageUrl = null;
          this.isDoublePic = true;
          this.leftImageUrl = params.mergeUrls[0];
          this.rightImagUrl = params.mergeUrls[1];
        }

        // if (params.mergeFlag) {
        //     this.isDoublePic = true
        //     const arr = params.mergeUrls.split(',')
        //     this.leftImageUrl = arr[0]
        //     this.rightImagUrl = arr[1]
        // } else {
        //     this.imageUrl = params.imageMessageUrl
        // }
      } else {
        this.upload = false;
        this.imageUrl = null;
      }
    },

    showModel() {
      this.showModelPop = !this.showModelPop;
    },
    uploadWork() { },
    switchDuble() {
      this.isDoublePic = !this.isDoublePic;
    },

    upTask(item) {
      topTask({
        contentId: item.id
      }).then(res => {
        console.log("top");
      });

      this.list.splice(this.list.indexOf(item), 1);
      this.list.unshift(item);
      this.$nextTick(() => {
        this.goTop();
      });
    },

    getUserRight() {
      getUserRight().then(res => {
        this.hasInpintRight = res.data.actions.indexOf("INPAINT") > -1;
      });
    },
    clickText(item) {
      const index = this.propTextList.indexOf(item);
      if (index != -1) {
        // 取消
        this.propMsg = this.propMsg.replace(item + ",", "");
        this.propTextList.splice(index, 1);
        return;
      }
      this.propTextList.push(item);
      if (this.propMsg) {
        this.propMsg = item + "," + this.propMsg;
      } else {
        this.propMsg = item + ",";
      }
    },
    async selectTab(item) {
      this.curSlectTabs = item;
      const l = await propDetail({ promptTypeId: item.id });
      this.propDetail = l.data;
    },

    hide() {
      this.showCollectPop = false;
    },
    openRegionPop(str, index) {
      this.inpintIndex = index;
      this.$nextTick(() => {
        // console.log('  hhh   ' + str)
        this.editRegionPop = true;
        this.regionctionPop = false;
        // console.log(this.$refs.shapeDrawer)
        this.$refs.shapeDrawer.changeImg(str);
      });
    },
    getUpScaleSinglePath(url) {
      return url + "?imageMogr2/thumbnail/400x/format/webp";
    },
    selectMoveCurAlbumPop(item) {
      this.moveCurAlbumPop = item;
    },
    moveOrCopy() {
      const obj = {
        albumId: this.moveCurAlbumPop.id
      };
      if (this.ids) {
        obj.ids = this.ids;
      } else {
        obj.ids = [this.moveImg.id];
      }
      if (this.curOption === "copy") {
        copyImage(obj).then(res => {
          if (this.ids) {
            this.switchMultOption();
          }
          this.$message({ type: "success", message: "复制成功" });
          this.hide();
          this.reloadAlbumList();
        });
      } else {
        moveImage(obj).then(res => {
          if (this.ids) {
            this.switchMultOption();
          }
          this.$message({ type: "success", message: "移动成功" });

          this.qeurySubListInfo();
          this.hide();
          this.reloadAlbumList();
        });
      }
    },
    slderChange(item) {
      item.enable = true;
    },

    switchFailList(show) {
      if (this.isShowFail != show) {
        this.isShowFail = show;
        // 重新加载所有数据
        this.pageNum = 1;
        this.pages = 1;
        this.list = [];
        this.onLoad();
      }
    },

    getUserParams() {
      const obj = {};
      if (this.curMoudleAction == 0) {
        obj.id = this.ruleTempId;
      } else {
        obj.id = this.ruleTempSdId;
      }


      obj.moduleList = JSON.parse(JSON.stringify(this.airules));
      if (!this.V6enable) {
        for (const it of obj.moduleList) {
          if (it.configType === 4) {
            it.check = null;
            it.switchCheck = false;
            it.uploadImagUrl = null;
          }
        }
      }

      const userOptions = [];
      let isHasRule = false;
      for (const it of obj.moduleList) {
        // 处理掉风格参考属性
        if (
          (it.configType !== 3 && it.check) ||
          (it.configType === 3 && it.enable)
        ) {
          isHasRule = true;
          if (it.configType === 0) {
            // it.checkSd = it.check;
            const arr = [it.check];
            it.check = arr;

          } else if (it.configType === 1) {
            // 多选暂时没有
          } else if (it.configType === 3) {
            if (it.enable) {
              const arr = [{ name: it.titleName, value: it.check }];
              it.check = arr;
            } else {
              it.check = null;
            }
          } else if (it.configType === 2) {
            const arr = [{ name: it.titleName, value: it.check ? "1" : "0" }];
            it.check = arr;
          }
          userOptions.push(it);
        } else if (it.configType === 3 && !it.enable) {
          it.check = null;
        }
      }

      return isHasRule ? JSON.stringify(obj) : null;
    },

    getUserParamsSd() {
      const obj = {};

      if (this.curMoudleAction == 0) {
        obj.id = this.ruleTempId;
      } else {
        obj.id = this.ruleTempSdId;
      }


      obj.moduleList = JSON.parse(JSON.stringify(this.airules));


      const userOptions = [];
      let isHasRule = false;
      for (const it of obj.moduleList) {
        // 处理掉风格参考属性
        if (
          (it.configType !== 3 && it.check) ||
          (it.configType === 3 && it.enable)
        ) {
          isHasRule = true;
          if (it.configType === 0) {

            it.check = it.check;

          } else if (it.configType === 4) {
            // 多选暂时没有
            it.check = it.check[0];
          } else if (it.configType === 1) {
            // 多选暂时没有
          } else if (it.configType === 3) {
            if (it.enable) {
              const arr = [{ name: it.titleName, value: it.check }];
              it.check = arr;
            } else {
              it.check = null;
            }
          } else if (it.configType === 2) {
            const arr = [{ name: it.titleName, value: it.check ? "1" : "0" }];
            it.check = arr;
          }
          userOptions.push(it);
        } else if (it.configType === 3 && !it.enable) {
          it.check = null;
        }
      }

      return isHasRule ? JSON.stringify(obj) : null;
    },
    async getRules() {
      const rl = await ruleList();
      this.ruleTempId = rl.data.records[0].id;

      const data1 = await getDetail({ id: this.ruleTempId });

      const data2 = await getSDDetail({ action: 'COMFYUIIMAGINE' });
      this.ruleTempSdId = data2.data.id
      // data.data.moduleList.sort((a, b) => {
      //     return a.orderNum < b.orderNum ? -1 : 1
      // })
      this.sdRuleDetail = data2.data.moduleList
      this.apiRuleDetail = data1.data.moduleList
      if (this.$route.params.engineType == '2') {

        this.curMoudleAction = '2'
      }
      const rules = this.curMoudleAction == '2' ? this.sdRuleDetail : this.apiRuleDetail


      for (const it of this.sdRuleDetail) {


        it.titleName = it.moduleName
        this.$set(it, 'switchCheck', false)

        it.orderNum = 0
        it.remark = ''



        if (it.moduleKey == 'weight_style') {
          it.subTitleName = '参考程度'
          it.configType = 4

        } else {
          it.configType = 0
        }

      }






      for (const it of this.apiRuleDetail) {

        if (it.mustFlag) {
          it.require = true;
        }
      }

      console.log(this.apiRuleDetail)
      // console.log('ggggggggggggggggggggggggggggggggg')
      console.log(this.sdRuleDetail)
      this.resetRules(rules);



      // this.resetRules(rules);
      this.airules = rules;
      // 添加提示词助理
      const l1 = await propTabList();
      this.propTabs = l1.data;
      this.curSlectTabs = this.propTabs[0];
      if (this.curSlectTabs) {
        const l2 = await propDetail({ promptTypeId: this.propTabs[0].id });
        this.propDetail = l2.data;
      }

      const l = await getDemoFlag();
      this.demoFlag = l.data == 3;

      // 初始设置完毕 可以匹配 文物
      if (this.$route.params.message) this.parsePageForTry(this.$route.params);
    },

    // 重置并添加模型
    resetRules(rules) {

      if (rules) {

        this.V6enable = true;
        for (const rule of rules) {
          if (rule.require) {
            // 必填参数必须要选
            const cl = rule.configList.filter((it, i) => it.defaultCheck);

            rule.check = cl.length == 1 ? cl[0] : rule.configList[0];
            // rule.check = rule.configList[0]
            if (rule.check.name == "写实") {
              this.V6enable = false;
            } else {
              this.V6enable = true;
            }

            continue;
          }

          if (rule.configType === 0) {
            rule.check = null;
          } else if (rule.configType === 1) {
            rule.check = null;
          } else if (rule.configType === 3) {
            rule.enable = false;
          } else if (rule.configType === 2) {
            rule.check = false;
          } else if (rule.configType === 4) {
            rule.switchCheck = false;
            rule.check = null;
            rule.uploadImagUrl = null;
          }
        }
      }
    },

    hidePop() {
      this.showSelectPop = false;
      this.getUserParams();
    },
    hideEditPop() {
      this.editRegionPop = false;
    },

    usercheck(item, it) {
      if (item.configType === 0) {
        // 单选
        //  item.check = it

        if (item.check == it && !item.require) {
          item.check = null;
        } else {
          item.check = it;
        }
        console.log(item.check);
        // 添加模型问题 如果模型是写实模型 则隐藏新模型参数
        if (item.titleName == "模型版本") {
          if (item.check.name == "写实") {
            // 清理掉v6模型参数
            this.V6enable = false;
            this.$message("写实模型不支持风格参考建议使用默认模型 写实2.0");
            // console.log('模型版本  xieshi ')
          } else {
            this.V6enable = true;
          }
        }

        //  this.$forceUpdate()
      } else if (item.configType === 1) {
        const checks = item.check ? item.check : [];
        checks.push(it);
        item.check = checks;
      } else if (item.configType === 4) {
        // 不可取消选项
        if (item.check == it) {
          item.check = null;
        } else {
          item.check = [it];
          //item.checkSd = it
        }
      }
    },

    async getChatTitleId() {
      if (!this.chatDetailId) {
        const res = await getTitleList({ type: this.chatType });
        for (const it of res.data.records) {
          if (it.chatType === 0) {
            this.chatDetailId = it.id;
            break;
          }
        }
      }
    },
    matchSelectModel(id) {
      for (const model of this.modelTypes) {
        for (const mo of model.modelFaceConfigList) {
          if (mo.id == id) {
            return mo;
          }
        }
      }
      return null;
    },

    async onLoad() {
      //  console.log('  llllll oad' + this.isLoading)
      // if (this.isLoading) {
      //     return
      // }

      // this.isLoading = true
      // 加载聊天信息
      if (!getToken()) {
        return;
      }
      await this.getChatTitleId();

      if (this.chatDetailId) {
        if (this.pageNum <= this.pages) {
          // 加载啊聊天信息
          getContentList({
            userChatTitleId: this.chatDetailId,
            states: this.isShowFail ? null : [0, 1, 2],
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            messageType: 1,
            action: "IMAGINE",
            actionType: 0
          }).then(res => {
            // this.getTasksForNewState(res.data.records)

            this.pageNum++;
            this.pages = res.data.pages;
            // for (const tt of res.data.records) {
            //     tt.width = 2048
            //     tt.height = 2048
            // }
            this.getAllImgSize(res.data.records);
          });
        } else {
          this.finished = true;
        }
      } else {
        // this.$message('没有创作记录')
        this.finished = true;
      }
    },

    getTasksForNewState(list) {
      // if (this.pageServerId) {
      //     clearInterval(this.pageServerId)
      // }

      if (!list) {
        return;
      }

      const ls = list.filter((it, i) => it.state === 2 && it.contentNo);
      if (ls && ls.length > 0) {
        this.sendMj(ls.map(it => it));
      }
    },
    pageForTasksList() {
      if (this.pageServerId) {
        clearInterval(this.pageServerId);
      }

      this.getTasksForNewState(this.list);
      this.pageServerId = setInterval(() => {
        this.getTasksForNewState(this.list);
      }, 60 * 1000);
    },
    getAllImgSize(list) {
      const delList = [];
      for (const nit of list) {
        for (const oit of this.list) {
          if (nit.id == oit.id) {
            delList.push(nit);
            break;
          }
        }
      }
      console.log(delList);
      for (const dit of delList) {
        list.splice(list.indexOf(dit), 1);
      }

      for (const item of list) {
        const src = item.replyMessage;
        item.isRunning = item.submmitQueueFlag == 0;
        if (item.state == 2) {
          const tp = this.taskMap[item.id];
          if (tp) {
            if (tp.submitTaskId) {
              clearInterval(tp.submitTaskId);
            }
            let et = item.estimatedTimes;
            this.$set(item, "endTime", et);
            this.$set(item, "progress", tp.progress + "%");
            tp.submitTaskId = setInterval(() => {
              //  const et = this.getItemEndTime(item.createTime, tp.maxP, 120000)
              //   et = item.estimatedTimes
              et = Math.max(10, item.endTime - 5);
              if (item.endTime <= 10) {
                clearInterval(tp.submitTaskId);
                console.log("clear endTime");
                return;
              }
              if (item.state != 2) {
                clearInterval(tp.submitTaskId);
                console.log("clear endTime");
                return;
              }
              this.$set(item, "endTime", et);
            }, 5000);
          }
        }
        if (!src) {
          continue;
        }
        if (item.action && item.action.indexOf("UPSAMPLE") > -1) {
          continue;
        }

        if (item.imgUrl1 && item.imgUrl2 && item.imgUrl3 && item.imgUrl4) {
          const img4For = [
            item.imgUrl1,
            item.imgUrl2,
            item.imgUrl3,
            item.imgUrl4
          ];
          this.$set(item, "img4For", img4For);

          continue;
        } else {
          if (item.width && item.height) {
            const picW = item.width / 2;
            const picH = item.height / 2;

            const arr = [
              picW + "x" + picH + "a0a0",
              picW + "x" + picH + "a" + picW + "a0",
              picW + "x" + picH + "a0" + "a" + picH,
              picW + "x" + picH + "a" + picW + "a" + picH
            ];
            const img4For = arr.map((it, index) => {
              return src + "?imageMogr2/crop" + "/!" + it;
            });

            this.$set(item, "img4For", img4For);
            continue;
          }
          const cacheImgImgInfo = sessionStorage.getItem(src);
          if (cacheImgImgInfo) {
            const info = JSON.parse(cacheImgImgInfo);
            const picW = info.width / 2;
            const picH = info.height / 2;

            const arr = [
              picW + "x" + picH + "a0a0",
              picW + "x" + picH + "a" + picW + "a0",
              picW + "x" + picH + "a0" + "a" + picH,
              picW + "x" + picH + "a" + picW + "a" + picH
            ];
            const img4For = arr.map((it, index) => {
              return src + "?imageMogr2/crop" + "/!" + it;
            });

            this.$set(item, "img4For", img4For);
            addImgInfo({
              id: item.id,
              width: info.width,
              height: info.height
            }).then(res => {
              console.log("发送成功");
            });
          } else {
            axios.get(src + "?imageInfo").then(response => {
              if (response.status == "200") {
                // this.imggesWithSizeData[src] = response.data
                // info = this.imggesWithSizeData[src]

                const info = response.data;
                sessionStorage.setItem(src, JSON.stringify(info));

                const picW = info.width / 2;
                const picH = info.height / 2;

                const arr = [
                  picW + "x" + picH + "a0a0",
                  picW + "x" + picH + "a" + picW + "a0",
                  picW + "x" + picH + "a0" + "a" + picH,
                  picW + "x" + picH + "a" + picW + "a" + picH
                ];
                const img4For = arr.map((it, index) => {
                  return src + "?imageMogr2/crop" + "/!" + it;
                });

                this.$set(item, "img4For", img4For);
                addImgInfo({
                  id: item.id,
                  width: info.width,
                  height: info.height
                }).then(res => {
                  console.log("发送成功");
                });

                // item.img4For = img4For
              }
            });
          }
        }
      }

      this.list.push(...list);
      this.pageForTasksList();

      if (this.list.length == 0) {
        this.finished = true;
      }
      this.isLoading = false;
    },

    // async getSingleImgSize(item) {

    //     // if (item === this.curPicInfo) {
    //     //     this.hasV6Params(this.curPicInfo.subText)
    //     // }
    //     if (item.action.indexOf('UPSAMPLE') > -1) {
    //         return
    //     }
    //     if (item.width && item.height) {
    //         const src = item.replyMessage
    //         console.log('fffff   tttttttttttttttt')
    //         const picW = item.width / 2
    //         const picH = item.height / 2

    //         const arr = [picW + 'x' + picH + 'a0a0',
    //         picW + 'x' + picH + 'a' + picW + 'a0
    //         picW + 'x' + picH + 'a0' + 'a' + picH,
    //         picW + 'x' + picH + 'a' + picW + 'a' + picH]
    //         const img4For = arr.map((it, index) => { return src + '?imageMogr2/crop' + '/!' + it })
    //         this.$set(item, 'img4For', img4For)
    //     } else {
    //         const src = item.replyMessage
    //         let info = sessionStorage.getItem(src)
    //         if (info) {
    //             info = JSON.parse(info)
    //         } else {

    //             const response = await axios.get(
    //                 src + '?imageInfo&t=' + new Date().getTime())

    //             if (response.status == '200') {
    //                 // this.imggesWithSizeData[src] = response.data
    //                 // info = this.imggesWithSizeData[src]

    //                 info = response.data
    //                 sessionStorage.setItem(src, JSON.stringify(info))
    //             }

    //             const picW = info.width / 2
    //             const picH = info.height / 2

    //             const arr = [picW + 'x' + picH + 'a0a0',
    //             picW + 'x' + picH + 'a' + picW + 'a0',
    //             picW + 'x' + picH + 'a0' + 'a' + picH,
    //             picW + 'x' + picH + 'a' + picW + 'a' + picH]
    //             const img4For = arr.map((it, index) => { return src + '?imageMogr2/crop' + '/!' + it })
    //             this.$set(item, 'img4For', img4For)
    //         }

    //         // item.img4For = img4For
    //     }

    // },
    showUploadWork(item, index) {
      item.caseIndex = index;
      this.$refs.uplaodTaskPop.open(item);
    },
    async getSingleImgSize(item) {
      // if (item === this.curPicInfo) {
      //     this.hasV6Params(this.curPicInfo.subText)
      // }
      if (item.action.indexOf("UPSAMPLE") > -1) {
        return;
      }
      if (item.replyMessage.indexOf(',') != -1) {
        console.log('vvvvvvvvvv      vbbbbbbbbbbbbbbbbbb ' + item.replyMessage)
        const img4For = item.replyMessage.split(',')
        this.$set(item, "img4For", img4For);
        item.img4For = img4For;
        return;
      }
      if (item.imgUrl1) {
        const img4For = [
          item.imgUrl1,
          item.imgUrl2,
          item.imgUrl3,
          item.imgUrl4
        ];
        this.$set(item, "img4For", img4For);
        return;
      }

      if (item.width && item.height) {
        const src = item.replyMessage;
        const picW = item.width / 2;
        const picH = item.height / 2;

        const arr = [
          picW + "x" + picH + "a0a0",
          picW + "x" + picH + "a" + picW + "a0",
          picW + "x" + picH + "a0" + "a" + picH,
          picW + "x" + picH + "a" + picW + "a" + picH
        ];
        const img4For = arr.map((it, index) => {
          return src + "?imageMogr2/crop" + "/!" + it;
        });
        this.$set(item, "img4For", img4For);
      } else {
        console.log("no width");

        const src = item.replyMessage;
        let info = sessionStorage.getItem(src);
        if (info) {
          info = JSON.parse(info);
        } else {
          const response = await axios.get(
            src + "?imageInfo&t=" + new Date().getTime()
          );

          if (response.status == "200") {
            // this.imggesWithSizeData[src] = response.data
            // info = this.imggesWithSizeData[src]

            info = response.data;
            sessionStorage.setItem(src, JSON.stringify(info));
          }

          const picW = info.width / 2;
          const picH = info.height / 2;

          const arr = [
            picW + "x" + picH + "a0a0",
            picW + "x" + picH + "a" + picW + "a0",
            picW + "x" + picH + "a0" + "a" + picH,
            picW + "x" + picH + "a" + picW + "a" + picH
          ];
          const img4For = arr.map((it, index) => {
            return src + "?imageMogr2/crop" + "/!" + it;
          });
          this.$set(item, "img4For", img4For);
        }

        item.img4For = img4For;
      }
    },
    selectScaleAction(item, index) {
      const createTime = new Date(item.createTime);
      const releaseDate = new Date(2024, 1, 15);
      if (item.isV5) {
        this.picAction(item, "UPSAMPLE4X" + index);
      } else {
        if (createTime.getTime() > releaseDate.getTime()) {
          this.picAction(item, "UPSAMPLE60" + index);
        } else {
          this.picAction(item, "UPSAMPLE4X" + index);
        }
      }
    },
    makeDoubleImgTask() {
      if (!this.leftImageUrl || !this.rightImagUrl) {
        this.$message("需要同时上传正反图");
        return;
      }
      if (this.propMsg && !/^[^\da-zA-Z\u4e00-\u9fa5]+$/u.test(this.propMsg)) {
        this.mergeImages();
        this.doublePicPop = false;
      } else {
        this.$message("需要填写提示词");
      }
    },

    bindRules(index) {
      this.showSelectPop = true;
      // 处理显示位置
      this.$nextTick(() => {
        console.log(this.$refs.ruleDiv);
        const l = this.$refs.ruleDiv[index];
        let scrollHeight = 0;
        for (const div of this.$refs.ruleDiv) {
          if (l === div) {
            break;
          }
          scrollHeight += div.offsetHeight;
        }
        console.log(scrollHeight);

        const options = {
          top: scrollHeight,
          behavior: "smooth"
        };

        this.$refs.ruleBg.scrollTo(options);
        console.log(this.$refs.ruleBg.scrollTo);
      });
    },

    parseError(item) {
      // SUBMIT(0, "提交"),
      //     DONE(1, "完成"),
      //     READING(2, "读取中"),
      //     SEND_ERR(3, "发送敏感词异常"),
      //     RECEIVE_ERR(4, "接收敏感词异常"),
      //     MJ_ERR(5, "Mj绘图错误");
      const state = item.state;
      let msg;
      if (state === 3) {
        msg = "发送敏感词异常";
      } else if (state === 4) {
        msg = "接收敏感词异常";
      } else if (state === 5) {
        msg = "Mj绘图错误";
      } else {
        msg = "其他错误";
      }
      if (item.status && item.status === "FAILURE") {
        msg += ",生成失败";
      }
      if (item.errMsg) {
        msg += "," + item.errMsg;
      }
      return msg;
    },
    formatDate(date, str) {
      return formatDate(date, str);
    },
    getSameOutPaintActionTask(id) {
      // const list = this.list.filter(it => it.action === 'OUTPAINT')
      //  console.log(list)
      // console.log('id  == ' + id)
    },
    // 图片变换命令
    picAction(item, action) {
      this.vactionPop = false;
      this.outactionPop = false;
      this.scaleActionPop = false;
      // 处理不能重复添加未完成的 相同拓绘任务

      // const task = this.getSameOutPaintActionTask(item.id)

      // if (task) {

      //     this.$message('请不要添加重复拓绘任务')
      //     return
      // }

      this.picItem = item;
      this.actionStr = action;
      // this.propMsgText = item.message
      this.actionMsg = item.id + " " + action;
      this.propMsg = item.message;
      if (this.actionMsg.substr(-1) === "OUTPAINT") {
        const sameTask = this.list.filter(it => {
          return it.actionMsg === this.actionMsg;
        });
        console.log(sameTask);
        if (sameTask.length > 0) {
          this.$message("请不要添加重复扩绘任务");
          return;
        }
      }
      if (action.charAt(0) === "V") {
        // 处理强弱
        if (!this.vactionStyle) {
          this.actionMsg = item.id + " LOWV" + action.substr(-1);
          this.actionStr = "LOWVARIATION";
        }
      }
      // 处理强弱V

      this.send();
    },
    listScroll(event) {
      if (this.$refs.vanList && this.$refs.vanList.$el.scrollTop) {
        this.showBackTop = this.$refs.vanList.$el.scrollTop > 200;
      } else {
        this.showBackTop = false;
      }
    },
    parseAction(str) {
      if (str === "LOWVARIATION") {
        return str;
      }
      if (str.indexOf("INPAINT") > -1) {
        return "INPAINT";
      }
      if (str.indexOf("UPSAMPLE") > -1) {
        return str.substring(0, str.length - 1);
      }
      if (str.indexOf("SEEDIMAGE") > -1) {
        return str.substring(0, str.length - 1);
      }

      if (str.substring(0, 2) === "OU") {
        // 视角上移
        return "OUTPAINT";
      }
      if (str.charAt(0) === "V") {
        return "VARIATION";
      } else if (str.charAt(0) === "U") {
        return "UPSCALE";
      } else {
        return "REROLL";
      }
    },
    async urlToImage(url) {
      try {
        // url = 'http://188lxx.oss-cn-hangzhou.aliyuncs.com/188lxx/imgnull/2/1700560967049.png'
        // url = 'https://7niu.ztxin.cn/ai/xiniao/user/20231121/87443/1700558413633lQ9V6a66Sb.png?imageMogr2/crop/!1024x1024a0a0/thumbnail/400x'
        const response = await fetch(url);
        const blob = await response.blob();

        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = reject;
          // img.crossOrigin = 'anonymous'
          img.src = URL.createObjectURL(blob);
        });
      } catch (error) {
        throw new Error("Failed to load image: " + error.message);
      }
    },

    async createNewImgAndUpload(url) {
      this.canvasRx = document.createElement("canvas");
      this.contextRx = this.canvasRx.getContext("2d");
      const img = await this.urlToImage(url);

      // 计算等比例缩放后的尺寸

      // 设置 Canvas 尺寸
      this.canvasRx.width = img.width;
      this.canvasRx.height = img.height;

      // 在 Canvas 上绘制图片
      this.contextRx.drawImage(img, 0, 0, img.width, img.height);
      this.contextRx.strokeStyle = "rgba(0, 0, 0, 0.5)"; // 设置线条颜色
      this.contextRx.lineWidth = 1; // 设置线条宽度

      // 绘制一条直线
      this.contextRx.beginPath(); // 开始路径
      const rx = Math.floor(Math.random() * 78);
      const ry = Math.floor(Math.random() * 48);
      this.contextRx.moveTo(rx, ry); // 设置起点坐标 (x, y)

      this.contextRx.lineTo(rx + 1, ry + 1); // 设置终点坐标 (x, y)
      this.contextRx.stroke(); // 绘制线条
      const image = this.canvasRx.toDataURL("image/png");

      const f = this.dataURItoBlob(image);
      const file = { file: new File([f], "aa.png", { type: "image/png" }) };
      // console.log(file)
      const newImagUrl = await upload(file, null, true);

      return newImagUrl;
    },
    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(",")[1]);
      const mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
      }

      return new Blob([arrayBuffer], { type: mimeString });
    },
    parseActionIndex() {
      if (this.actionMsg && this.actionMsg.indexOf("INPAINT") > -1) {
        return this.actionMsg.substr(-1);
      }
      if (this.actionMsg && this.actionMsg.indexOf("LOWV") > -1) {
        return this.actionMsg.substr(-1);
      }
      if (this.actionStr && this.actionStr.indexOf("OUTPAINT") > -1) {
        return this.actionStr.substr(-1);
      }
      if (this.actionStr && this.actionStr.indexOf("UPSAMPLE") > -1) {
        return this.actionStr.substr(-1);
      }
      if (this.actionStr && this.actionStr.indexOf("SEEDIMAGE") > -1) {
        return this.actionStr.substr(-1);
      }

      return null;
    },
    getItemFor4smallImg(src) {
      if (src.indexOf("imageMogr2") == -1) {
        return src + "?imageMogr2/thumbnail/400x/format/webp";
      } else {
        return src + "/thumbnail/400x/format/webp";
      }
    },
    removeNewlines() {
      // 去除输入内容中的换行符
      this.propMsg = this.propMsg.replace(/[\r\n]+/g, "");
    },
    async getBigItem4Img(src, index) {
      index = index - 1;

      let info = this.imggesWithSizeData[src];
      //
      if (!info) {
        const respnse = await axios.get(
          src + "?imageInfo&t=" + new Date().getTime()
        );

        if (respnse.status == "200") {
          this.imggesWithSizeData[src] = respnse.data;
          info = this.imggesWithSizeData[src];
        }
      }

      if (info) {
        const picW = info.width / 2;
        const picH = info.height / 2;

        const arr = [
          picW + "x" + picH + "a0a0",
          picW + "x" + picH + "a" + picW + "a0",
          picW + "x" + picH + "a0" + "a" + picH,
          picW + "x" + picH + "a" + picW + "a" + picH
        ];
        const realImgPath = src + "?imageMogr2/crop" + "/!" + arr[index];

        return realImgPath;
      } else {
        return null;
      }
    },

    goTop() {
      this.$refs.vanList.$el.scrollTo(0, 0);
    },
    downloadSingleImg(contentId, src, index) {
      downImageForApi(contentId, src, index);

      //   downloadSingleImg(contentId, src, index)
      this.downloadPop = false;
    },

    downloadImg(src, width, height) {
      this.downloadPop = false;
      if (this.isdownLoadImg) {
        this.$message("图片下载中...");
        return;
      }

      this.isdownLoadImg = true;
      if (width && height) {
        const picW = width / 2;
        const picH = height / 2;

        const arr = [
          picW + "x" + picH + "a0a0",
          picW + "x" + picH + "a" + picW + "a0",
          picW + "x" + picH + "a0" + "a" + picH,
          picW + "x" + picH + "a" + picW + "a" + picH
        ];
        let index = 0;
        const taskId = setInterval(
          () => {
            if (index < 4) {
              const url = src + "?imageMogr2/crop" + "/!" + arr[index];
              downloadSingleImg(url);

              index++;
            } else {
              clearInterval(taskId);
              this.isdownLoadImg = false;
            }
          },

          2000
        );
      } else {
        axios({
          url: src + "?imageInfo&t=" + new Date().getTime(),
          method: "GET"
        }).then(res => {
          if (res.status === 200) {
            const picW = res.data.width / 2;
            const picH = res.data.height / 2;

            const arr = [
              picW + "x" + picH + "a0a0",
              picW + "x" + picH + "a" + picW + "a0",
              picW + "x" + picH + "a0" + "a" + picH,
              picW + "x" + picH + "a" + picW + "a" + picH
            ];
            let index = 0;
            const taskId = setInterval(
              () => {
                if (index < 4) {
                  const url = src + "?imageMogr2/crop" + "/!" + arr[index];
                  downloadSingleImg(url);

                  index++;
                } else {
                  clearInterval(taskId);
                  this.isdownLoadImg = false;
                }
              },

              2000
            );
          }
        });
      }
    },

    getChatContentById(id) {
      // 区分两个

      for (const it of this.list) {
        if (it.id === id) {
          return it;
        }
      }
    },

    sendMj(cnos) {
      const subNewRecords = [];
      const needSubRecrods = [];
      for (const i of cnos) {
        let cr = null;
        for (const r of this.taskRecords) {
          if (i.contentNo == r.contentNo) {
            cr = r;
            break;
          }
        }
        if (cr) {
          if (cr.time < 10) {
            needSubRecrods.push(cr);
          }
          cr.time += 1;
        } else {
          cr = {};
          cr.contentNo = i.contentNo;
          cr.id = i.id;
          cr.time = 1;
          subNewRecords.push(cr);
          needSubRecrods.push(cr);
        }
      }
      this.taskRecords.push(...subNewRecords);

      cnos = needSubRecrods.map((it, index) => it.id);

      if (cnos.length > 0) {
        sendStatus({
          chatContentIds: cnos
        });
      }
      // 清除过期数据
      const newcrds = [];
      for (const rd of this.taskRecords) {
        for (const ld of this.list) {
          if (rd.contentNo == ld.contentNo && ld.state == 2) {
            newcrds.push(rd);

            break;
          }
        }
      }

      this.taskRecords = newcrds;
      console.log(this.taskRecords);
      sessionStorage.setItem(
        "taskRecordsBuild",
        JSON.stringify(this.taskRecords)
      );
    },
    expMenu() {
      if (this.showMenu) {
        //  document.querySelector('.chatList').style.width = '0rem'
        //  this.openMenu()
      } else {
        //  document.querySelector('.chatList').style.width = '1.7708rem'
      }
      this.showMenu = !this.showMenu;
    },

    openMenu() {
      const divElement = document.querySelector(".chatList");
      const currentWidth = divElement.style.width.split("rem")[0];
      console.log(currentWidth + "currentWidth   " + divElement.style.width);
      if (currentWidth > 0) {
        divElement.style.transitionDuration = ".5s"; // 设置过渡时间为0.5秒

        // 更新宽度并应用过渡效果
        if (currentWidth > 0.2) {
          divElement.style.width = currentWidth - 0.2 + "rem";
        } else {
          divElement.style.width = 0 + "rem";
        }

        setTimeout(this.openMenu(), 500); // 每50毫秒调用一次自身，直到达到目标宽度
      } else {
        console.log("动画结束！");
        this.showMenu = !this.showMenu;
      }
    },
    closeMenu() { },
    clearWorkspace() {
      this.resetRules(this.airules);
      this.propMsg = null;
      this.imageUrl = null;
      this.modelImg = null;
      this.curPicInfo = {};
    },

    getPrompt() {
      const obj = {};
      //    obj.id = this.ruleTempId;
      //   obj.moduleList = JSON.parse(JSON.stringify(this.airules));
      const params = {};
      const userOptions = [];
      let isHasRule = false;
      for (const it of obj.moduleList) {
        if (!it.check) {
          continue
        }
        if (
          (it.configType !== 3 && it.check) ||
          (it.configType === 3 && it.enable)
        ) {
          isHasRule = true;
          if (it.configType === 0) {
            params[it.moduleKey] = it.check.key;
            // const arr = [it.check]
            // it.check = it.check
          } else if (it.configType === 1) {
            // 多选暂时没有
          } else if (it.configType === 3) {
            if (it.enable) {
              const arr = [{ name: it.titleName, value: it.check }];
              it.check = arr;
            } else {
              it.check = null;
            }
          } else if (it.configType === 2) {
            const arr = [{ name: it.titleName, value: it.check ? "1" : "0" }];
            it.check = arr;
          }
          userOptions.push(it);
        } else if (it.configType === 3 && !it.enable) {
          it.check = null;
        }
      }

      return JSON.stringify(params);
    },

    // 图片生成
    onImgExport(imgData, inpintStr) {
      this.mask = imgData;
      this.inpaintPrompt = inpintStr;
      this.editRegionPop = false;
      this.picAction(this.curPicInfo, "INPAINT" + this.inpintIndex);
    },
    handleUpload(file) {
      upload(file).then(res => {
        this.imageUrl = res;
      });
    },
    handleLeftUpload(file) {
      upload(file).then(res => {
        this.leftImageUrl = res;
      });
    },
    handleRightUpload(file) {
      upload(file).then(res => {
        this.rightImagUrl = res;
      });
    },

    handleFGUpload(file) {
      const name = file.action;
      const list = this.airules.filter((it, index) => it.titleName == name);

      console.log(list);
      upload(file).then(res => {
        list[0].uploadImagUrl = res;
        if (!list[0].check) {
          list[0].check = [list[0].configList[0]];
        }

        //  this.$forceUpdate()
      });
    },
    // 写一个函数 函数参数接收一个时间戳 例如 2024-03-15 17:00:36 返回转成Date
    fourmatDate(dataStr) {
      const time = new Date(dataStr).getTime();
      const newDate = new Date().getTime();
      //  console.log(time + '    ' + newDate)
      if (newDate - time > 1000 * 120) {
        return true;
      }
      return false;
    },

    retryAdd(item) {
      // 先删除后提交
      // 将一个格式好的时间戳转成时间 在比对当前时间 判断时间差
      if (this.fourmatDate(item.createTime)) {
        this.restCurPic(item);
        this.send();
        this.deleteRecord(item);
      } else {
        this.$message("任务仍在执行中");
      }
    },

    // 合并图片
    mergeImages() {
      const image1 = new Image();
      const image2 = new Image();
      // 先加载1图片 在加载2图片 完成后合并
      image1.onload = () => {
        image2.onload = () => {
          // 创建一个新的Canvas元素
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // 设置Canvas的尺寸，使其足够大以容纳两张图片
          canvas.width = image1.width + image2.width;
          canvas.height = Math.max(image1.height, image2.height); // 假设两张图片的高度相同，或者你可以根据需要调整

          // 在Canvas上绘制图片
          ctx.drawImage(image1, 0, 0);
          ctx.drawImage(image2, image1.width, 0);

          // 导出图片为Data URL（你也可以选择导出为Blob）
          const image = canvas.toDataURL("image/png");
          const f = this.dataURItoBlob(image);
          const file = { file: new File([f], "aa.png", { type: "image/png" }) };
          // console.log(file)
          upload(file).then(res => {
            this.imageUrl = res;
            this.send();
          });
        };
        image2.crossOrigin = "anonymous";
        image2.src = this.rightImagUrl;
      };
      image1.crossOrigin = "anonymous";
      image1.src = this.leftImageUrl;
    },

    sendForType() {
      if (this.isDoublePic && this.upload) {
        this.makeDoubleImgTask();
      } else {
        this.send();
      }
    },

    async send() {
      // if (this.leftImageUrl) {
      //     this.mergeImages()
      // }

      // 判断维护状态
      // bus.$emit('showServiceMaintain', '维护服务信息维护服务信息维护服务信息维护服务信息维护服务信息')
      // // if (bus) {
      // //     bus.$emit('showServiceMaintain')
      // //     return
      // // }
      // const res = await checkServiceStasus()
      // if (res.data) {
      //     // 显示维护通知弹窗
      //     bus.$emit('showServiceMaintain')
      //     return
      // }

      // 处理合并

      const _this = this;

      if (this.succeed) {
        // 校验

        const str = this.actionStr ? this.actionMsg : this.propMsg;
        //   this.scrollChat()
        if (str && !/^[^\da-zA-Z\u4e00-\u9fa5]+$/u.test(str)) {
          //  if (str.indexOf("-") > -1) {
          //    this.$message("请不要输入特殊 - 符号");
          //   return;
          //  }
          this.succeed = false;

          // 打包数据
          if (this.upload && !this.imageUrl) {
            this.$message("请上传图片或者关闭上传参考图功能后重试");
            this.succeed = true;
            return;
          }

          await this.packetStructure(this.propMsg);
          const c = this.curPicInfo;
          c.engineType = this.curMoudleAction
          try {
            this.temp = "";
            let chatContent = await this.add({
              message: str,
              messageType: "1"
            });

            if (chatContent.code == 999) {
              bus.$emit("showServiceMaintain", chatContent.message);
              this.succeed = true;
              return;
            }
            this.curPicInfo.isV6 = this.isV6 = chatContent.data.isV6;
            this.curPicInfo.isV5 = this.isV5 = chatContent.data.isV5;
            this.curPicInfo.isTile = this.UPSAMPLE = chatContent.data.isTile;
            if (this.isDoublePic) {
              this.imageUrl = null;
            }

            this.mask = null;
            if (this.inpaintPrompt != null) {
              this.propMsg = this.inpaintPrompt;
            }
            this.inpaintPrompt = null;

            chatContent = chatContent.data;
            if (str.indexOf("UPSAMPLE4X") > -1) {
              // 提示
              const tip = localStorage.getItem("textImg");
              if (!tip) {
                this.$message("放大任务较为消耗算力,请谨慎使用");
                localStorage.setItem("textImg", new Date().getTime());
              }
            }

            // 处理如果没有titleId则会新建对话问题
            await this.getChatTitleId();
            this.actionStr = null;
            this.picItem = null;
            this.vactionStyle = true;

            c.id = chatContent.id;
            c.createTime = new Date(chatContent.createTime).getTime();
            //  this.list.push(c.id)
            if (chatContent.state === 0) {
              // 需要订购
              this.$message.error("没有绘图次数了");
              bus.$emit("showNoPic");
              this.succeed = true;
              c.state = 0;
              return;
            }
            if (chatContent.state === 3) {
              this.$message.error("内容不合规,请勿询问敏感内容!");

              this.succeed = true;
              c.state = 3;
              return;
            }
            this.propTextList.splice(0, this.propTextList.length);

            c.prestate = 1;
            const task = {
              progress: 0,
              createTime: new Date().getTime(),
              maxP: 30 + Math.floor(5 * Math.random())
            };
            this.taskMap[c.id] = task;

            c.state = chatContent.state;
            c.contentNo = chatContent.contentNo;

            c.refreshTaskId = setInterval(() => {
              if (c.state == 2) {
                // 查询最新状态
                getInfoForItem({ id: c.id }).then(res => {
                  const data = res.data;
                  // data.width = 2048
                  // data.height = 2048
                  if (c.state == 2) {
                    if (data.state == 1) {
                      c.prestate = 3;
                      c.state = 1;
                      c.width = data.width;
                      c.height = data.height;
                      this.$set(c, "replyMessage", data.replyMessage);
                      this.$set(c, "progress", null);
                      this.getSingleImgSize(c);
                      // 获取图片实际大小 开始分割图片
                      this.$set(c, "progress", "100%");
                      this.$set(c, "prestate", 3);
                      this.$set(c, "state", 1);

                      clearInterval(c.refreshTaskId);
                    } else if (data.state == 5) {
                      this.$set(c, "prestate", 1);
                      this.$set(c, "state", 5);
                      this.$set(c, "progress", null);
                      this.$set(c, "status", data.status);

                      this.$set(
                        c,
                        "errMsg",
                        data.errorMsg || "提交绘图任务失败"
                      );
                      clearInterval(c.refreshTaskId);
                    }
                  } else {
                    clearInterval(c.refreshTaskId);
                  }
                });
              } else {
                clearInterval(c.refreshTaskId);
              }
            }, 30000);
            this.list.unshift(c);
            this.refreshTaskIdList.push(c.refreshTaskId);
            //

            // 设置预计默认时间
            this.$set(c, "endTime", chatContent.estimatedTimes);
            task.submitTaskId = setInterval(() => {
              // const et = this.getItemEndTime(c.createTime, task.maxP, c.estimatedTime)

              let et = c.endTime;

              et = Math.max(et - 5, 10);

              if (et <= 10) {
                clearInterval(task.submitTaskId);
                console.log("clear add endTime");
                return;
              }
              if (c.state != 2) {
                clearInterval(task.submitTaskId);
                console.log("clear add endTime");
                return;
              }
              this.$set(c, "endTime", et);
            }, 5000);
            localStorage.setItem("taskMap", JSON.stringify(this.taskMap));

            for (var i = 0; i < chatContent.childs.length; i++) {
              const child = chatContent.childs[i];
              child.prestate = 1;
              child.state = chatContent.state;
              this.list.unshift(child);
            }

            // 1秒后可以重发
            setTimeout(() => {
              _this.succeed = true;
            }, 2000);
            const cons = chatContent.contentNos || [chatContent.contentNo];
            sendMj({ userChatContentNos: cons });
            // 添加动画开始
          } catch (e) {
            // 当前坐标
            //  this.chat.splice(this.chat.length - 1, 1);
            // this.out(e, size);
            c.replyMessage = "系统繁忙,请稍后再试";
            this.succeed = true;
            console.log(e.message);
          } finally {
            c.isShow = true;
            c.reply = true;
          }
          // 设置超时刷新
        } else {
          this.$message({ message: "需要填写提示词", type: "warning" });
        }
      } else {
        this.$message({ message: "请等待绘图完成", type: "warning" });
      }
    },

    forceLoadReq() {
      // 任务提交成功  添加定时任务 3分钟后 刷新任务列表 获取任务状态
      // this.pendingAITasks.push(chatContent.id)
      // const curPendTaskId = setTimeout(() => {
      //     // 查看任务是否已经成功
      //     const c = this.getChatContentById(chatContent.id)
      //     if (!c) {
      //         return
      //     }
      //     if (c.state === 2) {
      //         // 任务还在跑 则刷新
      //         detail({ id: chatContent.id }).then(res => {
      //             // 如果状态不一样 则替换当前状态
      //             console.log(res.data)
      //             if (res.data.state === 1) {
      //                 // 任务已完成
      //                 c.prestate = 3
      //                 c.state = 1
      //                 this.$set(c, 'replyMessage', data.imgUrl)
      //                 this.$set(c, 'progress', null)
      //                 this.getSingleImgSize(c)
      //                 // 获取图片实际大小 开始分割图片
      //                 this.$set(c, 'progress', '100%')
      //                 this.$set(c, 'prestate', 3)
      //                 this.$set(c, 'state', 1)
      //                 this.$forceUpdate()
      //                 console.log('task  catch')
      //             } else if (res.data.state === 5) {
      //                 // 任务失败
      //                 c.prestate = 1
      //                 c.state = 5
      //                 c.progress = null
      //                 c.errMsg = data.errorMsg || '提交绘图任务失败'
      //                 this.$forceUpdate()
      //                 console.log('task  catch')
      //             }
      //             this.$forceUpdate()
      //         })
      //     }
      // }, 3 * 60 * 1000)
      // console.log(curPendTaskId)
    },
    rotaeUploadImg() {
      this.deg += 90;
    },
    setTaskDesc() {
      this.curPicInfo.taskDesp =
        (this.picItem ? this.picItem.id : null) +
        (this.actionStr ? this.parseAction(this.actionStr) : null) +
        "_" +
        this.parseActionIndex(this.actionStr);
    },
    getBorderStyle(index) {
      if (index == 0) {
        return {
          borderRadius: "10px 0px 0px 0px"
        };
      } else if (index == 1) {
        return {
          borderRadius: "0px 10px 0px 0px"
        };
      } else if (index == 2) {
        return {
          borderRadius: "0px 0px 0px 10px"
        };
      } else {
        return {
          borderRadius: "0px 0px 10px 0px"
        };
      }
    },
    packetStructure(input) {
      this.curPicInfo = {};
      this.curPicInfo.message = input;
      this.curPicInfo.isRunning = false;
      this.curPicInfo.queueTip = "";
      this.curPicInfo.endTime = 120;
      this.curPicInfo.modelFaceConfigId = this.modelImg
        ? this.modelImg.id
        : null;
      this.curPicInfo.createTime = new Date().getTime();
      this.$set(this.curPicInfo, "endTime", 120);
      //  this.curPicInfo.endTime = 120
      this.curPicInfo.imageMessageUrl = this.imageUrl;
      this.curPicInfo.messageType = "1";
      //   this.curPicInfo.prestate = 1
      this.curPicInfo.progress = "0%";
      this.curPicInfo.actionMsg = this.actionMsg;
      this.curPicInfo.action = this.actionStr
        ? this.actionStr
        : this.imageUrl
          ? "IMAGINE"
          : null;
      this.curPicInfo.subText = this.getUserParams();
      this.curPicInfo.inpaintPrompt = this.inpaintPrompt;
      if (this.leftImageUrl && this.rightImagUrl) {
        this.curPicInfo.mergeFlag = "1";
        this.curPicInfo.mergeUrls = this.leftImageUrl + "," + this.rightImagUrl;
      }
    },
    prevBigForImg(data, index, width, height) {
      if (Array.isArray(data)) {
        if (data[0].indexOf("?") == -1) {
          this.imageData = data.map(
            (it, index) =>
              it + "?imageMogr2/format/webp/" + width / 2 + "x" + height / 2
          );
          this.prevWidth = width / 2;
          this.prevHeight = height / 2;
        } else {
          this.imageData = data.map(
            (it, index) => it + "/format/webp/" + width / 2 + "x" + height / 2
          );
        }

        this.viewerIndex = index;
      } else {
        this.imageData = [
          data + "?imageMogr2/format/webp/" + width + "x" + height
        ];
      }

      this.showImageViewer = true;
    },
    getImgBg(item) {
      if (item.albumBackImageUrl) {
        return {
          backgroundImage:
            "url(" +
            item.albumBackImageUrl +
            "?imageView2/2/w/400/h/400/format/webp&x-oss-process=image/resize,m_fill,h_400,w_400" +
            ")"
        };
      } else {
        return { backgroundImage: "url(/static/images/mywork_empty.png)" };
      }
    },
    reUpload() {
      this.$refs.upload.submit();
    },
    uploadSwitch() {
      if (!this.upload) {
        this.imageUrl = null;
      }
    },
    uploadItemSwitch(item) {
      if (item) {
        item.uploadImagUrl = null;
        item.check = null;
      }
    },

    scrollBot() {
      setTimeout(() => {
        const div = document.getElementsByClassName("picbg")[0];
        div.scrollTop = div.scrollHeight;
        // div.offset = document.scrollHeight
      }, 100);
    },
    showSelectpop(item) {
      this.showSelectPop = true;
    },
    hideDoublePop() { },

    mjcon() {
      // 区分命令
      const eventSource = mjChatStream(
        data => {
          this.recontime = 0;

          if (data.realContentId && data.status === "FAILURE") {
            data.id = data.realContentId;
          }

          const c = this.getChatContentById(data.id);
          if (!c) {
            return;
          }
          // 处理排队问题

          if (data.hasOwnProperty("submmitQueueFlag")) {
            if (data.submmitQueueFlag == 0) {
              getInfoForItem({ id: c.id }).then(res => {
                c.isRunning = true;
                c.endTime = res.data.estimatedTimes;
                this.$forceUpdate();

                //

                console.log("aaaaaaa    " + (c === this.curPicInfo));
              });
            } else {
              this.$set(c, "queueTip", "任务智能排队中");
            }

            // 重新获取时间

            return;
          }
          if (!data.status) {
            return;
          }
          // 不需要显示排队数量
          // if (data.submmitQueueNo) {
          //     //this.$set(c,"")
          //     return
          // }

          const task = this.taskMap[data.id];
          if (data.action === "UPSCALE") {
            return;
          }

          if (c.state == 1 || c.state == 5 || c.replyMessage) {
            console.log("done");
            // 状态已经固定 不需要处理后续
            return;
          }

          if (data.status === "FAILURE") {
            if (task && task.taskId) {
              clearInterval(task.taskId);
            }
            this.$set(c, "prestate", 1);
            this.$set(c, "state", 5);
            this.$set(c, "progress", null);
            this.$set(c, "status", data.status);

            this.$set(c, "errMsg", data.errorMsg || "提交绘图任务失败");

            this.succeed = true;
            // bbbbbbbbbbbbbbbbb
          } else {
            c.width = data.width;
            c.height = data.height;
            // 真实进度回调
            if (document.hidden && data.progress == "100%") {
              // 页面不可见状态 并且任务已经走完
              console.log("task done  window is hidden ");
              if (task && task.taskId) {
                clearInterval(task.taskId);
              }
              c.prestate = 3;
              c.state = 1;
              c.width = data.width;
              c.height = data.height;
              if (data.imgUrl1) {
                c.imgUrl1 = data.imgUrl1;
                c.imgUrl2 = data.imgUrl2;
                c.imgUrl3 = data.imgUrl3;
                c.imgUrl4 = data.imgUrl4;
              }
              this.$set(c, "replyMessage", data.imgUrl);
              this.$set(c, "progress", null);
              this.getSingleImgSize(c);
              // 获取图片实际大小 开始分割图片
              this.$set(c, "progress", "100%");
              this.$set(c, "prestate", 3);
              this.$set(c, "state", 1);

              return;
            }

            if (task) {
              // 有保存上次进度
              let dataProgressInt = Number.parseInt(
                data.progress.substring(0, data.progress.length - 1)
              );
              if (dataProgressInt != 100) {
                dataProgressInt += Math.floor(3 * Math.random());
              }

              if (dataProgressInt == 100) {
                try {
                  if (task) {
                    clearInterval(task.taskId);
                  }
                  if (!task) {
                    //   this.$message('请刷新页面重试')
                    return;
                  }

                  task.endTaskId = setInterval(() => {
                    if (task.progress < 99) {
                      task.progress += 1;
                      data.progress = task.progress + "%";
                      this.$set(c, "prestate", 2);
                      this.$set(c, "progress", data.progress);
                      this.$set(c, "replyMessage", data.imgUrl);
                      this.$set(c, "status", data.status);
                      this.$set(c, "action", data.action);

                      this.$forceUpdate();
                    } else {
                      clearInterval(task.endTaskId);
                      delete this.taskMap[data.id];
                      localStorage.setItem(
                        "taskMap",
                        JSON.stringify(this.taskMap)
                      );
                      c.prestate = 3;
                      c.state = 1;
                      c.width = data.width;
                      c.height = data.height;
                      this.$set(c, "replyMessage", data.imgUrl);
                      this.$set(c, "progress", null);
                      this.getSingleImgSize(c);
                      // 获取图片实际大小 开始分割图片
                      this.$set(c, "progress", "100%");
                      this.$set(c, "prestate", 3);
                      this.$set(c, "state", 1);

                      //   this.$forceUpdate()
                    }
                  }, 40);
                } catch (e) {
                  console.log(e.message);
                }
              } else {
                // 区分阶段
                // 取消当前 任务  看当前任务最大进度是多少
                // 如果小于当前进度 则修改最大进度 按比例缩减等候值
                if (task) {
                  clearInterval(task.taskId);
                }
                // if (task) {
                //     clearInterval(task.submitTaskId)
                // }
                if (data.status === "IN_PROGRESS") {
                  if (task && !task.taskId) {
                    // 初次进入任务添加
                    console.log("dddddddddddddd");
                    task.taskId = setInterval(() => {
                      if (task.progress < task.maxP) {
                        task.progress += 1;
                        data.progress = task.progress + "%";
                        localStorage.setItem(
                          "taskMap",
                          JSON.stringify(this.taskMap)
                        );
                        this.$set(c, "prestate", 2);
                        this.$set(c, "progress", data.progress);
                        this.$set(c, "replyMessage", data.imgUrl);
                        this.$set(c, "status", data.status);
                        this.$set(c, "action", data.action);

                        //  this.$forceUpdate()

                        // 设置进度
                      } else {
                        clearInterval(task.taskId);
                      }
                    }, 1000);
                  } else if (task && task.taskId) {
                    // 任务已经在跑了  判断快慢
                    if (task.maxP < dataProgressInt) {
                      // 计算差值 如果超过30  则加快 未超过则正常速度
                      const abs = dataProgressInt - task.progress;
                      //   console.log(abs)
                      task.maxP = dataProgressInt;
                      let timeSpan;
                      if (abs < 30) {
                        timeSpan = 850;
                      } else if (abs > 30 && abs < 60) {
                        timeSpan = Math.floor(500);
                      } else if (abs > 60 && abs < 90) {
                        timeSpan = Math.floor(50);
                      } else {
                        timeSpan = 10;
                      }
                      //  console.log(timeSpan)
                      task.taskId = setInterval(() => {
                        if (task.progress < task.maxP) {
                          task.progress += 1;
                          localStorage.setItem(
                            "taskMap",
                            JSON.stringify(this.taskMap)
                          );
                          data.progress = task.progress + "%";
                          this.$set(c, "prestate", 2);
                          this.$set(c, "progress", data.progress);
                          this.$set(c, "replyMessage", data.imgUrl);
                          this.$set(c, "status", data.status);
                          this.$set(c, "action", data.action);

                          this.$forceUpdate();
                        } else {
                          clearInterval(task.taskId);
                        }
                      }, timeSpan);
                    } else {
                      // 已经等于最大进度 则卡着不动
                      if (task.progress < task.maxP) {
                        task.taskId = setInterval(() => {
                          if (task.progress < task.maxP) {
                            task.progress += 1;
                            localStorage.setItem(
                              "taskMap",
                              JSON.stringify(this.taskMap)
                            );
                            data.progress = task.progress + "%";
                            this.$set(c, "prestate", 2);
                            this.$set(c, "progress", data.progress);
                            this.$set(c, "replyMessage", data.imgUrl);
                            this.$set(c, "status", data.status);
                            this.$set(c, "action", data.action);

                            this.$forceUpdate();
                          } else {
                            clearInterval(task.taskId);
                          }
                        }, 500);
                      } else {
                        this.$set(c, "prestate", 2);
                        this.$set(c, "progress", task.progress + "%");
                        this.$set(c, "replyMessage", data.imgUrl);
                        this.$set(c, "status", data.status);
                        this.$set(c, "action", data.action);

                        // this.$forceUpdate()
                      }
                    }
                  }
                }
              }

              this.$set(c, "status", data.status);
              this.$set(c, "action", data.action);
              this.$set(c, "errMsg", data.errorMsg);
              // this.$forceUpdate()
            } else {
              if (data.progress == "100%") {
                c.prestate = 3;
                c.state = 1;
                this.$set(c, "replyMessage", data.imgUrl);
                this.$set(c, "progress", null);
                c.width = data.width;
                c.height = data.height;
                this.getSingleImgSize(c);
                // 获取图片实际大小 开始分割图片
                this.$set(c, "progress", "100%");
                this.$set(c, "prestate", 3);
                this.$set(c, "state", 1);

                //  this.$forceUpdate()
              } else {
                this.$set(c, "prestate", 2);
                this.$set(c, "progress", data.progress);
                this.$set(c, "replyMessage", data.imgUrl);
                this.$set(c, "status", data.status);
                this.$set(c, "action", data.action);

                // this.$forceUpdate()
              }
            }
          }

          c.isShow = true;
          c.reply = false;
        },
        close => {
          // 延迟1s重连
          if (
            !eventSource.__CLOSED &&
            (!this.recontime || this.recontime < 10)
          ) {
            setTimeout(() => {
              if (this.recontime) {
                this.recontime++;
              } else {
                this.recontime = 1;
              }
              this.mjcon();
            }, 1000 * this.recontime);
          }
        },

        err => {
          if (
            !eventSource.__CLOSED &&
            (!this.recontime || this.recontime < 10)
          ) {
            setTimeout(() => {
              if (this.recontime) {
                this.recontime++;
              } else {
                this.recontime = 1;
              }
              this.mjcon();
            }, 1000 * this.recontime);
          }
        }
      );
      this.mjEventSource = eventSource;
    },
    async add({ message, aiChatTypeDetailId, messageType }) {
      // if (this.imageUrl != null) {

      //     this.imageUrl = await this.createNewImgAndUpload(this.imageUrl)
      // }
      const ruleParams = this.airules;
      const ls = ruleParams.filter((it, i) => it.configType == 4);

      for (const lt of ls) {
        if (lt.uploadImagUrl && !lt.check) {
          this.$message("需选择对应参数");
          return;
        } else if (!lt.uploadImagUrl && lt.check) {
          this.$message("需上传图片 ");
          return;
        }
      }
      const imgUrlRls = this.leftImageUrl + "," + this.rightImagUrl;


      const action = this.actionStr ? this.parseAction(this.actionStr) : "IMAGINE"
      const engineType = action == 'IMAGINE' ? this.curMoudleAction : 0
      const obj = {
        engineType,
        message: message,
        messageType: aiChatTypeDetailId ? 0 : messageType,
        chatType: this.chatType,
        actionType: 0,
        checkParams:
          this.actionStr && !this.isV6 && !this.isV5 && !this.UPSAMPLE
            ? undefined
            : this.getUserParams(),
        imageMessageUrl: this.imageUrl,
        userChatTitleId: this.chatDetailId,
        equityType: this.equityType,
        inpaintPrompt: this.inpaintPrompt,
        relationId: this.picItem ? this.picItem.id : undefined,
        action,
        index: this.parseActionIndex(this.actionStr),
        mask: this.mask,
        mergeUrls: this.isDoublePic ? imgUrlRls : undefined,
        mergeFlag: this.isDoublePic ? "1" : "0",
        modelFaceConfigId: this.modelImg ? this.modelImg.id : undefined
      }
      if (engineType == '2') {
        obj.checkParamsSd = this.getUserParamsSd()
      }
      const res = await add(obj);

      return res;
    },

    getMixImg(item) {
      const url = item.replyMessage;
      if (url.indexOf("?") != -1) {
        return item.replyMessage + "/thumbnail/400x/format/webp";
      } else {
        return (
          item.replyMessage +
          "?imageView2/2/w/400/h/400/format/webp&x-oss-process=image/resize,m_fill,h_400,w_400"
        );
      }
    },
    deleteRecord(item) {
      remove({ id: item.id }).then(res => {
        const i = this.list.indexOf(item);
        this.list.splice(i, 1);
        if (this.curPicInfo === item) {
          this.curPicInfo = {};
          this.resetRules(this.airules);
          this.upload = false;

          this.propMsg = null;
        }
      });
    },
    handleAvatarSuccess() { },

    beforeAvatarUpload() { },
    // 载入旧图片
    async restCurPic(item) {
      // 匹配 模特
      //  this.modelImg = this.matchSelectModel(item.modelFaceConfigId);
      this.leftImageUrl = null;
      this.rightImagUrl = null;
      this.isV6 = item.isV6;
      this.isV5 = item.isV5;
      this.UPSAMPLE = item.isTile;
      this.vactionStyle = true;
      this.curPicInfo = item;
      this.curPicInfo.prestate = 3;
      this.propMsg = item.inpaintPrompt || item.message;
      this.curMoudleAction = item.engineType == 2 ? '2' : '0'
      this.slectAr(this.curMoudleAction)
      this.resetHisPicRules(this.curPicInfo.subText);
      if (item.imageMessageUrl) {
        this.upload = true;
        this.imageUrl = null;
        this.isDoublePic = false;
        if (item.mergeFlag) {
          this.isDoublePic = true;
          const arr = item.mergeUrls.split(",");
          this.leftImageUrl = arr[0];
          this.rightImagUrl = arr[1];
        } else {
          this.imageUrl = item.imageMessageUrl;
        }
      } else {
        this.upload = false;
        this.imageUrl = null;
      }
    },

    clickCollectImg(id, ids) {
      this.collectPop = false;
      const obj = {
        id: id,
        index: ids
      };
      addCollect(obj).then(res => {
        this.$message({ type: "success", message: "收藏成功" });
      });
    },

    // 重置规则
    resetHisPicRules(subText) {

      this.resetRules(this.airules);

      if (this.curMoudleAction == 0) {
        this.airules = this.apiRuleDetail
      } else {
        this.airules = this.sdRuleDetail
      }

      if (!subText) {
        return;
      }
      console.log(this.airules);

      const obj = JSON.parse(subText).moduleList;

      for (const i of obj) {
        const iname = i.titleName;

        for (const jt of this.airules) {
          if (iname == jt.titleName && i.configType == jt.configType) {
            // 规则匹配
            if (
              (i.configType != 3 && i.check) ||
              (i.configType === 3 && i.enable)
            ) {
              if (jt.configType === 0) {
                // 兼容测试版

                jt.check = i.check[0];
                // 处理是否显示v6
                if (jt.titleName == "模型版本") {
                  if (jt.check.name == "写实") {
                    // 清理掉v6模型参数
                    this.V6enable = false;
                    //   console.log('模型版本  xieshi ')
                  } else {
                    this.V6enable = true;
                  }
                  const isHaveMoudle = jt.configList
                    .map(it => it.name)
                    .indexOf(jt.check.name);
                  if (isHaveMoudle == -1) {
                    jt.check = jt.configList[0];
                  }
                }
              } else if (jt.configType === 1) {
                jt.check = i.check;
              } else if (jt.configType === 2) {
                jt.check = i.check;
              } else if (jt.configType === 3) {
                jt.check = i.check[0].value;
                jt.enable = true;
              } else if (jt.configType === 4) {
                jt.switchCheck = i.switchCheck;
                jt.uploadImagUrl = i.uploadImagUrl;
                jt.check = i.check;
              }
              break;
            } else {
              if (jt.configType === 0 && !jt.require) {
                jt.check = null;
              } else if (jt.configType === 1) {
                jt.check = null;
              } else if (jt.configType === 2) {
                jt.check = false;
              } else if (jt.configType === 3) {
                jt.enable = false;
              }
              break;
            }
          }
        }
      }
      // console.log('ppppp   ' + this.V6enable)

      //  this.$forceUpdate()
    },
    showAddPop() {
      this.showCollectPop = true;
    },
    onCopy() { },
    getItemEndTime(endTime, realProgress, planTime) {
      // 如果有进度 计算进度剩余时间
      let et;
      if (realProgress && realProgress > 35) {
        et = Math.floor((planTime / 1000 / 2) * ((100 - realProgress) / 100));
      } else {
        et = Math.floor((endTime + planTime - new Date().getTime()) / 1000);
      }

      return Math.max(et, 10);
    },

    onError() { }
    // getData() {
    //     console.log('全部加' + this.pageNum + '   ' + this.pages)
    //     if (this.isLoading) {
    //         return
    //     }
    //     if (this.pageNum > this.pages) {
    //         console.log('全部加载完毕了' + this.pageNum + '   ' + this.pages)
    //         this.$refs.waterfall.waterfallOver()

    //         return
    //     }
    //     getImageList({
    //         pageNum: this.pageNum,
    //         pageSize: this.pageSize
    //     }).then(res => {

    //         for (const item of res.data.records) {
    //             if (item.replyMessage) {
    //                 this.imgsArr.push({
    //                     src: item.replyMessage + '?imageView2/2/w/440/h/440&x-oss-process=image/resize,m_fill,h_440,w_440',
    //                     rawImg: item.replyMessage

    //                 })
    //             }
    //         }
    //         this.isLoading = false
    //         this.pageNum++

    //     })
    // }
  },
  components: {
    vueWaterfallEasy,
    shapeDrawer,
    uploadWorkPop,
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer")
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.listTab {
  width: 100%;
  display: flex;
  height: 100%;
  font-size: 16px;
  color: #eff8ff;
}

.moveOrCopy {
  position: relative;
  display: flex;
  color: #fff;
  padding-top: 14px;
  width: 706px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.ltab_n {
  width: calc(100% - 50px);
  margin-left: 25px;
  margin-right: 25px;
  height: calc(100% - 2px);
  text-align: center;
  line-height: 40px;
  border-bottom: 2px solid transparent;
}

.ltab {
  width: calc(100% - 50px);
  margin-left: 25px;
  margin-right: 25px;
  height: calc(100% - 2px);
  text-align: center;
  line-height: 40px;
  border-bottom: 2px solid #00d0ff;
}

button {
  outline: none;
  color: white;
  border: none;
  padding: 0;
  font-size: 16px;
  margin: 0;
  background: none;
  background-image: none;
}

.reUpload {
  margin-top: 24px;
  width: 219px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 54px;
  line-height: 50px;
  font-size: 18px;
  background: #03aff4;
  border-radius: 10px;
}

.reUpload:hover {
  margin-top: 24px;
  width: 219px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 54px;
  line-height: 50px;
  font-size: 18px;
  background: #0488c6;
  border-radius: 10px;
}

.menus {
  width: 120%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.parent {
  height: 100%;
  color: #e2f1ff;
  font-size: 14px;
  background: #000000;
}

.rightList {
  width: 277px;
  height: calc(100% - 1px);
  border-left: 1px solid #2d3345;
  border-top: 1px solid #2d3345;
  position: relative;
  background: #141825;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

/* .rightTtile {
    height: 50px;
    font-size: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-left: 14px;
    border-bottom: 1px solid #2D3345;
    width: calc(100% - 14px);
} */
.rightTtile {
  height: 45px;
  font-size: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  padding-left: 14px;
  border-bottom: 1px solid #2d3345;
  width: calc(100% - 14px);
}

.arrimg {
  width: 9px;
  margin-left: 6px;
  margin-top: 2px;
  height: 16px;
}

.resetBtn {
  border-radius: 10px;
  border: 1px solid rgba(19, 203, 248, 1);
  width: 180px;
  height: 54px;
}

.ruleLl {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resetBtns {
  display: flex;
  align-items: center;
  width: calc(100% - 400px);
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 24px;
}

.btnLl :first-child {
  margin-left: 10px;
}

.setBtn {
  width: 180px;
  height: 54px;
  background: #06caf9;
  border-radius: 10px;
}

button {
  background: none;
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
}

.singImgBtn {
  position: absolute;
  bottom: 20px;
  width: 119px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 50%;
  transform: translateX(-50%);
  background: #03b0f4;
  border-radius: 9px;
}

.picTitle {
  font-size: 16px;
}

.roate {
  position: absolute;
  right: calc(50% - 25px);
  bottom: 100px;
  width: 50px;
  height: 30px;
  border-radius: 4px;
  background: #03aff4;
  line-height: 30px;
  font-size: 14px;
}

.waterfall {
  height: 100%;
  width: 100%;
}

.switchBtn {
  width: 140px;
  font-size: 20px;
  color: #fff;
}

.ver {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

div::-webkit-scrollbar {
  display: none;
}

.close {
  width: 22px;
  height: 22px;
  top: 40px;
  right: 40px;
  display: none;
  position: absolute;
}

div::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 5px;
  display: none;
}

.singBtns {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pop {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.493);
}

.sliderText {
  margin-left: 12px;
  margin-right: 6px;
  color: #fff;
  width: 60px;
  font-size: 14px;
}

.placeHolderPre {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  border: 1px solid #2d3345;
  border-radius: 14px;
  bottom: 0;
  background-size: 100% 100%;

  overflow-y: hidden;
  overflow-x: hidden;

  background-size: 100% 100%;
  background-image: url("/static/images/masaikebg.png");
}

.leftMenuBtn {
  width: 120px;
  height: 44px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2d3345;
  border-radius: 8px;
}

.doublePicimg {
  width: 160px;
  height: 160px;
  position: relative;
}

.doubleEnnuBtn {
  width: 132px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  background: #01a8f4;
  border-radius: 9px;
}

.doubleEnnuBtn img {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}

.leftMenuBtn img {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}

.btnUpload {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  width: 100%;
  height: 100%;
}

.image-slot {
  width: 100%;
  height: 100%;
}

.placeHolderPreError {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  border: 1px solid #2d3345;
  border-radius: 14px;
  bottom: 0;
  background-size: 100% 100%;
  background-image: url("/static/images/shengchengshibai.png");
}

.placeHolderPreError span {
  margin-top: 90px;
  font-size: 15px;
}

.btopBtn {
  width: 22px;
  height: 22px;
  background-image: url("/static/images/backTopList.png");
  position: absolute;
  right: 10px;
  top: 10px;
  background-size: 100% 100%;
}

.btopBtn:hover {
  width: 22px;
  height: 22x;
  background-image: url("/static/images/backTopListF.png");
  position: absolute;
  right: 10px;
  top: 10px;
  background-size: 100% 100%;
}

.el-popper[x-placement^="bottom"] .popper__arrow::after {
  order-bottom-color: #2f2929;
}

.placeHolderIv {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-image: url("/static/images/img_placeholder.png");
  background-size: 100% 100%;
}

.doubleImgicon {
  margin-bottom: 4px;
  width: 40px;
  height: 40px;
  background-size: 100% 100%;
  background-image: url("/static/images/pic2uploadimg.png");
}

.leftBtn {
  position: absolute;
  left: 0;
}

>>>.el-card__body {
  padding: 0;
}

.ll {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-right: 20px;
  border-bottom: 1px solid #2d3345;
}

.llB {
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: calc(100% - 40px);
  margin-left: 20px;
  height: 50px;
  margin-right: 20px;
}

.btnLl {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btnDivider {
  width: 1px;
  height: 30px;
  margin-right: 10px;
  background: #455077;
}

.border {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 398px;
  height: 398px;
  background: #151825;
  border-radius: 9px;
  border: 1px solid #363c52;
}

.popLl {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-right: 20px;
  font-size: 18px;
  color: #e2f1ff;
}

>>>.el-switch__core {
  width: 40px;
}

.ruleList {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  padding-top: 16px;
  align-items: center;
  width: 100%;
}

>>>.el-upload--text {
  width: 100%;
  height: 100%;
}

.ruleItem {}

.indexbar {
  background: #1fd5ff;
  margin-right: 20px;
  width: 4px;
  height: 14px;
}

.workItemPop {
  width: 20%;
  height: 160px;
  padding: 4px 2px 0px 2px;
  box-sizing: border-box;
  position: relative;
}

.popRoot {
  width: 100%;
  height: 100%;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 15px;
  color: #ffffff;
  position: relative;
}

.rulesContent {
  height: 0;
  flex: 1;

  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.uploadIv {
  margin-bottom: 4px;
  width: 24px;
  height: 24px;
  background-size: 100% 100%;
  background-image: url("/static/images/clickupload.png");
}

.fileImg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.uploadBg {
  display: flex;
  width: 100px;
  font-size: 11px;
  height: 100px;
  background: #10131e;
  border-radius: 0.052083rem;
  border: 1px solid #434d6d;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.singPic {
  width: 100%;
  height: 100%;
  background: #19213c;
  position: relative;
}

.ruleUpload {
  width: 114px;
  height: 114px;
  font-size: 11px;
}

.picItem {
  width: 100%;
  padding-bottom: 24px;
}

.moveItemTitle {
  font-size: 12px;
  width: 100%;
  height: 34px;
  line-height: 34px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

>>>.el-main {
  padding: 0;
}

.picbg {
  width: calc(100% - 28px);
  margin-left: 4px;
  margin-right: 14px;
  margin-top: 20px;
  height: 0;
  flex: 1;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 13px;
  background-color: #141825;
}

.selectAddPop {
  width: 800px;
  background: #141825;
  border-radius: 13px;
  border: 1px solid;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 1%;
}

.empty {
  width: calc(100% - 28px);
  margin-left: 14px;
  margin-right: 14px;
  margin-top: 14px;
  height: 0;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 13px;
  font-size: 20px;
  color: #fff;
}

.popBtnLl {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.pic2pic {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}

.workList {
  width: calc(100% - 30px);
  padding-left: 15px;
  padding-left: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.dimgplaceBg {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.empty span {
  margin-top: 24px;
  margin-bottom: 24px;
}

.van-list {
  width: 100%;
  height: 0;
  flex-shrink: 0;
  flex-grow: 1;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
}

.van-list::-webkit-scrollbar {
  display: none;
}

.workItemContent {
  position: relative;
  padding: 7px;
  background-size: 100% 100%;
  border-radius: 14px;
  width: calc(100% - 14px);
  height: calc(100% - 14px);
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.workItemContent_s {
  position: relative;
  padding: 6px;
  background-size: 100% 100%;
  border-radius: 14px;
  width: calc(100% - 28px);
  height: calc(100% - 28px);
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #03aff4;
}

.empty img {
  width: 440px;
  height: 440px;
}

.popClose {
  position: absolute;
  right: 30px;
  top: 14px;
  width: 18px;
  height: 18px;
}

.avatar-uploader {
  margin-top: 24px;
  margin-bottom: 24px;

  margin-left: 24px;
  width: 100px;
  height: 100px;
  background: #261863;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;

  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.rightList span {
  font-size: 16px;
  color: #eff8ff;
}

.imgContent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 200px;
  margin: 8px;
  position: relative;
  height: 260px;
  align-items: center;
}

.tag {
  width: 180px;
  height: 60px;
  border-radius: 8px;
  border: 1px solid transparent;
  color: #fff;
  text-align: center;
  line-height: 60px;
  margin: 24px 24px 0px 24px;
  background: #0f131e;
}

.propTag {}

.tagFlex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tagImg {
  width: 140px;
  height: 140px;
  border-radius: 8px;
  border: 1px solid transparent;
  color: #fff;
  text-align: center;
  line-height: 60px;
  margin: 24px 24px 0px 24px;
  background: #0f131e;
}

.tag:hover {
  width: 180px;
  height: 60px;
  border-radius: 8px;
  color: #fff;
  text-align: center;
  line-height: 60px;
  margin: 24px 24px 0px 24px;
  background: #1f253a;
}

.tagImg:hover {
  width: 140px;
  height: 140px;
  border-radius: 8px;
  color: #fff;
  text-align: center;
  line-height: 60px;
  margin: 24px 24px 0px 24px;
  background: #1f253a;
}

.popTitle {
  font-size: 0.0938rem;
  margin-bottom: 0.125rem;
  text-align: left;
  width: 100%;
  padding-left: 80px;
}

.tag_s {
  width: 180px;
  height: 60px;
  border-radius: 8px;
  border: 1px solid #1fd5ff;
  color: #fff;
  text-align: center;
  line-height: 60px;
  margin: 24px 24px 0px 24px;
  background: #1f253a;
}

.tagImg_s {
  width: 140px;
  height: 140px;
  border-radius: 8px;
  border: 1px solid #1fd5ff;
  color: #fff;
  text-align: center;
  line-height: 60px;
  margin: 24px 24px 0px 24px;
  background: #1f253a;
}

.imgaeList {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.tagImg_s img {
  width: 60px;
  height: 60px;
  margin-top: 34px;
}

.tagImg img {
  width: 60px;
  height: 60px;
  margin-top: 34px;
}

.checkBorder {
  width: 200px;
  height: 260px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  border: 2px solid #f00;
}

.imgTitle {
  height: 30px;
}

.itemImg {
  width: 200px;
  height: 200px;
}

.sliderBar {
  width: 100px;
  flex: 1;
  margin-left: 14px;
}

.sliderBarBig {
  width: 420px;
  min-width: 420px;
  max-width: 420px;
  align-self: center;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 400px;
  height: 400px;
  line-height: 400px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.draw {
  position: relative;
  width: 100%;
  height: calc(100% - 40px);
}

.drawParent {
  display: flex;
  box-sizing: border-box;
  width: 0px;
  flex-grow: 1;
  height: calc(100% - 10px);
  padding-bottom: 10px;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ruleScoll {
  width: 100%;
  height: 500px;
  overflow-y: scroll;
}

.drawRoot {
  width: 100%;
  height: 100%;
  margin: 0;
  background: #000000;
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
}

.el-image {
  width: 220px;
  height: 220px;
}

.bigWidth {
  width: 230px;
  height: 230px;
  border-radius: 10px;
}

.picimgS {
  width: 100%;
  height: 100%;
  border-radius: 0px;
}

.listCoverRetry {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: #3027277d;
}

.picimgSList {
  width: 100%;
  height: 100%;
  border-radius: 0px;
}

.singleImg {
  width: 100%;
  height: 100%;
  position: relative;
}

.singleImg:hover .uploadWork {
  position: absolute;
  right: 20px;
  top: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  height: 25px;
  display: block;
  padding-left: 6px;
  padding-right: 6px;
  line-height: 25px;
  height: 25px;
  background: #03a8f4;
  border-radius: 12px;
}

.uploadWork {
  display: none;
  background: none;
  outline: none;
  border: none;
}

.singleImgList {
  width: 100%;
  height: 100%;
}

.arls {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  color: #fff;
}

.arls button {
  margin: 10px;
  height: 54px;
  color: #fff;
  padding-left: 24px;
  padding-right: 24px;
  background: #00000d;
  border-radius: 10px;
  border: 2px solid transparent;
}

.arls button:hover {
  margin: 10px;
  height: 54px;
  padding-left: 24px;
  padding-right: 24px;
  background: #2b3657;
  border-radius: 10px;
  border: 2px solid transparent;
}

.arls button.check {
  margin: 10px;
  height: 54px;
  padding-left: 24px;
  padding-right: 24px;
  background: #2b3657;
  border-radius: 10px;
  border: 2px solid #1fd5ff;
}

.upimg {
  width: 400px;
  height: 400px;
}

/* .dupimg {
    width: 360px;
    height: 360px;

} */
.dupimg {
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  border-radius: 18px;
  border: 1px solid #363c51;
  justify-content: center;
}

.dupIconimg {
  width: 40px;
  height: 40px;
}

.switchToOne {
  width: 167px;
  height: 47px;
  background: #1a1f32;
  color: #03a8f4;
  display: flex;
  outline: none;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 5 27px 5px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  align-self: flex-start;
  margin-top: 24px;
}

.recordItem {
  width: 230px;
  height: 230px;
  border-radius: 10px;
  margin: auto;
  align-self: center;
  margin-top: 24px;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.doublePopTitle {
  width: 100%;
  text-align: center;
  margin-bottom: 18px;
  line-height: 30px;
  font-size: 22px;
  color: #fff;
}

.recordItem_c {
  width: 232px;
  height: 232px;
  border-radius: 10px;
  margin: auto;
  align-self: center;
  margin-top: 24px;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  border: 1px solid #03a8f4;
}

.recordItem:last-of-type {
  margin-bottom: 40px;
  height: 100px;
}

/* .recordItem_c:last-of-type {
    margin-bottom: 40px;
    height: 100px;
} */

.leftRoot {
  background: #141825;
  position: relative;
  border-right: 1px solid #2d3345;
  border-top: 1px solid #2d3345;
  height: calc(100% - 1px);
  position: relative;
  width: calc(100% - 20px);
  overflow-y: auto;
  display: flex;
  font-size: 18px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
}

.rulellBtn {
  width: 100%;
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: space-between;
}

.leftRoot_e {
  background: #141825;
  position: relative;
  border-right: 1px solid #524587;
  height: 100%;
  position: relative;
  width: 0%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
}

.reUploadIv {
  width: 20px;
  height: 20px;
  margin-right: 14px;
}

.expBtn {
  position: absolute;
  right: 0;
  top: calc(50% - 50px);
  height: 40px;
  width: 20px;
  background: #1c2134;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.workItemImg {
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  background-size: 100% 100%;
  border: 2px solid transparent;
  border-radius: 10px;
}

.workItemImg_s {
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  background-size: 100% 100%;
  border: 2px solid #00d0ff;
  border-radius: 10px;
}

>>>.van-list__finished-text {
  margin-top: 40px;
  margin-bottom: 20px;
}

>>>.el-textarea__inner {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

.shape {
  width: 0;
  height: 0;
  transform: translateX(-50%);
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid transparent;
  border-right: 8px solid #9098b4;
}

.shapeR {
  width: 0;
  height: 0;
  transform: translateX(30%);
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #bfb3e8;
  border-right: 8px solid transparent;
}

.recordItem_c:hover .listCover {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #0000007a;
}

.recordItem:hover .listCover {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #0000007a;
}

.doubleInput {
  width: 834px;
  padding: 6px;
  margin-top: 18px;
  position: relative;
  height: 126px;
  background: #141825;
  border-radius: 18px;
  border: 1px solid #363c51;
}

.doubleSendBtn {
  width: 128px;
  height: 35px;
  line-height: 35px;
  background: #03a8f4;
  border-radius: 7px;
  position: absolute;
  right: 40px;
  top: 60px;
  color: #fff;
  font-size: 16px;
}

.recordItem:hover .listCover .listDelete {
  width: 30px;
  height: 30px;
  background-size: 100% 100%;
  background-image: url("/static/images/list_delete.png");
  position: absolute;
  right: 20px;
  top: 20px;
}

.recordItem_c:hover .listCover .listDelete {
  width: 30px;
  height: 30px;
  background-size: 100% 100%;
  background-image: url("/static/images/list_delete.png");
  position: absolute;
  right: 20px;
  top: 20px;
}

.recordItem:hover .listCover .listUp {
  width: 30px;
  height: 30px;
  background-size: 100% 100%;
  background-image: url("/static/images/shuaxin.png");
  position: absolute;
  right: 60px;
  top: 20px;
}

.recordItem_c:hover .listCover .listUp {
  width: 30px;
  height: 30px;
  background-size: 100% 100%;
  background-image: url("/static/images/shuaxin.png");
  position: absolute;
  right: 60px;
  top: 20px;
}

.editBot {
  margin-top: 20px;
  width: calc(100% - 14px - 14px);
  margin-left: 14px;
  margin-right: 14px;
  background: #141825;
  border-radius: 20px;
  border: 1px solid #363c51;
}

.editDivider {
  width: calc(100% - 28px);
  margin-left: 14px;
  margin-right: 14px;
  background: #4e5366;
}

.exchangeImg {
  background: #999;
  border-radius: 6px;
  position: absolute;
  bottom: 10px;
  padding: 5px 5px 5px 5px;
  right: 25%;
  font-size: 12px;
}

.editBg {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 14px;
  padding-right: 14px;
  position: relative;
}

.switch {
  width: 50px;
}

>>>.switchVation {
  margin-left: 10px;
  margin-right: 10px;
}

.input {
  width: 100%;
  height: 100%;
  background: none;
  padding-top: 10px;
  outline: none;
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

>>>.el-textarea__inner {
  background: none;
  background-color: none;
  border: none;
  font-size: 18px;
  color: #ffffff;
}

textarea {
  background: none;
  background-color: none;
  border: none;
  color: #ffffff;
  font-size: 14px;
}

.sendBtn {
  width: 130px;
  height: 44px;
  background: #03a8f4;
  border-radius: 16px;
  line-height: 44px;
  position: absolute;
  font-size: 20px;
  right: 10px;
  color: #fff;
  bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sendBtnLeft {
  width: 130px;
  line-height: 44px;
  height: 44px;
  background: #03a8f4;
  border-radius: 16px;
  position: absolute;
  font-size: 20px;
  left: 10px;
  color: #fff;
  top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selectPop {
  width: 70%;
  background: #141825;
  height: 80%;
  border-radius: 13px;
  border: 1px solid;
  position: absolute;
  left: 15%;
  right: 15%;
  top: 2%;
}

.selectPopProp {
  width: 70%;
  background: #141825;
  height: 65%;
  border-radius: 13px;
  border: 1px solid;
  position: absolute;
  left: 15%;
  right: 15%;
  top: 2%;
}

.editRegionPop {
  width: 800px;
  background: #141825;
  height: 600px;
  border-radius: 13px;
  border: 1px solid;
  position: absolute;
  left: calc((100% - 800px) / 2);
  top: calc((100% - 640px) / 4);
}

.doubleImgPop {
  width: 940px;
  background: #141825;
  height: 620px;
  border-radius: 13px;
  border: 1px solid;
  position: absolute;
  left: calc((100% - 940px) / 2);
  top: calc((100% - 620px) / 4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.popClose {
  position: absolute;
  right: 30px;
  top: 14px;
  width: 18px;
  height: 18px;
}

.llBtns {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 40px;
  margin-top: 40px;
}

.popoverBackB {
  background: #303133 !important;
}

.progressDiv {
  position: absolute;
  flex-direction: column;
  left: 0px;
  top: 0px;
  background: #000;
  right: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pic_progress {
  background-size: 100% 100%;
  width: 400px;
  height: 300px;
}

@keyframes fadenum {
  100% {
    transform: rotate(360deg);
  }
}

.menu {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: #ff0;
  margin-top: 20px;
  width: 100%;
}

.btn {
  background: #1f253a;
  color: #dfe5ef;
  font-size: 14px;
  width: 64px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  text-align: center;
  line-height: 27px;
  border-radius: 7px;
}

.btnText {
  color: #dfe5ef;
  font-size: 14px;

  margin-right: 2px;

  height: 30px;

  line-height: 27px;
  margin-left: 10px;
}

.btnText:last-child {
  margin-left: 2px;
}

.itBbtn {
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding-left: 11px;
  white-space: nowrap;
  padding-right: 11px;
  border: 1px solid #545c6f;
  color: #fff;
  font-size: 15px;
}

.itBbtn:hover {
  height: 42px;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  background: #2b324b;
  border-radius: 8px;
  padding-left: 11px;
  padding-right: 11px;
  border: 1px solid #8795b6;
  color: #fff;
  font-size: 15px;
}

.itBbtn img {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}

/* .itBbtn {
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    padding-left: 21px;
    white-space: nowrap;
    padding-right: 21px;
    border: 1px solid #545C6F;
    color: #fff;
    font-size: 15px;
}

.itBbtn:hover {
    height: 42px;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
    background: #2B324B;
    border-radius: 8px;
    padding-left: 21px;
    padding-right: 21px;
    border: 1px solid #8795B6;
    color: #fff;
    font-size: 15px;
}

.itBbtn img {
    width: 18px;
    height: 18px;
    margin-right: 16px;
} */

.btn:hover {
  background: #2b3657;
  color: #dfe5ef;
  font-size: 14px;
  width: 64px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  text-align: center;
  line-height: 27px;
  border-radius: 7px;
}

.picimgN {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  /* background-image: linear-gradient(45deg, #282828 25%, transparent 0, transparent 75%, #282828 0), linear-gradient(45deg, #282828 25%, transparent 0, transparent 75%, #282828 0);
    background-position: 0 0, 15px 15px;
    background-size: 30px 30px;
    background-repeat: repeat; */

  overflow-y: hidden;
  overflow-x: hidden;
}

.placeImg {
  overflow-y: hidden;
  overflow-x: hidden;
  width: 390px;
  height: 390px;
  background-size: 100% 100%;
  background-image: url("/static/images/masaikebg.png");
}

.picimg {
  width: 400px;
  position: relative;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-size: 100% 100%;
  /* background-image: linear-gradient(45deg, #282828 25%, transparent 0, transparent 75%, #282828 0), linear-gradient(45deg, #282828 25%, transparent 0, transparent 75%, #282828 0);
    background-position: 0 0, 15px 15px;
    background-size: 30px 30px;
    background-repeat: repeat; */

  overflow-y: hidden;
  overflow-x: hidden;

  background-size: 100% 100%;
}

.dpicimg {
  width: 360px;
  position: relative;
  height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-size: 100% 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  overflow-x: hidden;
  position: relative;
  background-size: 100% 100%;
  background-image: url("/static/images/masaikebg.png");
  background-size: 100% 100%;
  color: #fff;
}

.gridImgList {
  display: grid;
  width: 230px;
  height: 230px;
  grid-template-rows: 110px 110px;
  /* 两行，每行占相等的空间 */
  grid-template-columns: 110px 110px;
  /* 两列，每列占相等的空间 */
  grid-row-gap: 10px;
  grid-column-gap: 10px;
  flex-shrink: 0;
}

.gridImg {
  display: grid;
  width: 390px;
  height: 390px;
  grid-template-rows: 190px 190px;
  /* 两行，每行占相等的空间 */
  grid-template-columns: 190px 190px;
  /* 两列，每列占相等的空间 */
  grid-row-gap: 10px;
  grid-column-gap: 10px;
  flex-shrink: 0;
}

.btn img {
  width: 16px;
  height: 16px;
}

.progress {
  color: #fff;
  font-size: 14px;
}

.Listprogress {
  width: 100%;
  height: 4px;
}

.errText {
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.errMsg {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  padding: 4px;
  font-size: 12px;
  position: absolute;

  left: 30px;

  right: 30px;
  bottom: 20px;
  background: #556673;
}

#errmsgIv {
  width: 16px;
  height: 17px;
  margin-right: 10px;
}

.failIv {
  background-image: url("/static/images/shengchengshibai.png");
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  position: relative;
}

.progressBg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #000;
  position: relative;
  border-radius: 10px;
}

#proIv {
  width: 200px;
  height: 150px;
}

.llSwtich {
  width: 100%;
  height: 50px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.itemProgerss {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 20px;
}

/* ?菜单动画 */
.slidLeft-enter-active,
.slidLeft-leave-active {
  transition: all 0.3s ease;
}

.slidLeft-enter {
  transform: scaleX(0);
  transform-origin: 0px 50%;
  opacity: 0;
}

.slidLeft-enter-to {
  transform: scaleX(1);
  transform-origin: 0px 50%;
  opacity: 1;
}

.slidLeft-leave {
  transform: scaleX(1);
  transform-origin: 0px 50%;
  opacity: 1;
}

.slidLeft-leave-to {
  transform: scaleX(0);
  transform-origin: 0px 50%;
  opacity: 0;
}

.propTabs {
  width: calc(100% - 110px - 110px);
  padding-left: 110px;
  padding-right: 110px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.selTabBtn {
  background: none;
  background: #03aff4;
  border-radius: 24px;
  padding-left: 25px;
  height: 48px;
  padding-right: 25px;
  margin-right: 15px;
  font-size: 18px;
  line-height: 48px;
}

.TabBtn {
  background: none;
  background: #000000;
  border-radius: 24px;
  padding-left: 25px;
  height: 48px;
  padding-right: 25px;
  margin-right: 15px;
  font-size: 18px;
  line-height: 48px;
}

.TabBtn:hover {
  background: none;
  background: #03aff4;
  border-radius: 24px;
  padding-left: 25px;
  height: 48px;
  padding-right: 25px;
  margin-right: 15px;
  font-size: 18px;
  line-height: 48px;
}

.propGrid {
  display: grid;
  width: calc(100% - 100px - 100px);
  padding-left: 100px;
  padding-right: 100px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px;
  padding: 10px;
  box-sizing: border-box;
  max-height: 100%;
  overflow-y: scroll;
}

.tabDivider {
  width: calc(100% - 110px - 110px);
  height: 1px;
  margin-left: 110px;
  margin-right: 110px;
  background: #03b0f492;
  margin-top: 30px;
  margin-bottom: 30px;
}

.modelItem {
  width: 164px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 164px;
}

.modelSpan {
  position: absolute;
  width: 145px;
  height: 30px;
  line-height: 30px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  bottom: 40px;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.propGrid button {
  border: 1px solid transparent;
  color: #fff;
  height: 48px;
  border-radius: 8px;
  background: #0f131e;
}

.propGrid button:hover {
  border: 1px solid transparent;
  color: #fff;
  height: 48px;
  background: #2b3657;
  border-radius: 8px;
}

.propGrid button.sel {
  border: 1px solid transparent;
  color: #fff;
  height: 48px;
  background: #2b3657;
  border-radius: 8px;
  border: 1px solid #1fd5ff;
}

.modelImg {
  width: 60px;
  height: 60px;
  position: relative;
}

.modelText {
  height: 60px;
  position: relative;
  line-height: 60px;
}

.modelCleanBtn {
  display: none;
}

.modelImg:hover .modelCleanBtn {
  position: absolute;
  display: block;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 12px;
  background: #01a8f4;
  border-radius: 12px;
  margin: auto auto;
  height: 24px;
  margin-left: 5px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/build/index.vue